import { _LOCAL_BUILD, _WEBSITE_VERSION } from './config'
import { fixNumber, sortData } from './util'

export const windowConfirm = {
  default: 'CONSTANT.global.data.windowConfirm.___default'
}

export const defaultEmptyDisplay = {
  empty: 'CONSTANT.global.data.defaultEmptyDisplay.___empty',
  noKey: 'CONSTANT.global.data.defaultEmptyDisplay.___noKey'
}

export const pageDisplay = {
  item: 'CONSTANT.global.data.pageDisplay.___item',
  display: 'CONSTANT.global.data.pageDisplay.___display',
  jump: 'CONSTANT.global.data.pageDisplay.___jump',
  page: 'CONSTANT.global.data.pageDisplay.___page'
}

export const projectState = {
  created: 'CONSTANT.global.data.projectState.___created',
  uploading: 'CONSTANT.global.data.projectState.___uploading',
  analyzing: 'CONSTANT.global.data.projectState.___analyzing',
  started: 'CONSTANT.global.data.projectState.___analyzing',
  completed: 'CONSTANT.global.data.projectState.___completed',
  failed: 'CONSTANT.global.data.projectState.___failed',
  no_affected: 'CONSTANT.global.data.projectState.___noAffected'
}

export const jobState = {
  running: 'CONSTANT.global.data.jobState.___running',
  default: 'CONSTANT.global.data.jobState.___default'
}

export const parseUserSetting = setting => {
  let userColumns = [...(setting.report_preview_af_columns || [])]
  let previewColumnMap = ['pd', 'ps'].reduce((map, key) => ({ ...map, ...reportPreviewOptions[key].filter(option => !option.old).reduce((map, option) => ({ ...map, [option.key]: true }), {}) }), {})
  userColumns = userColumns.filter(column => previewColumnMap[column])
  return {
    ...setting,
    report_preview_af_columns: userColumns
  }
}

export const priceMap = {
  'vcf': {
    price: 59
  },
  'fastq': {
    price: 99
  }
}

export const impactMap = {
  'HIGH': {
    color: '#FA3D3D',
    font: 'white'
  },
  'MODERATE': {
    color: '#F8C600',
    font: '#333333'
  },
  'LOW': {
    color: '#83C91E',
    font: '#333333'
  },
  'MODIFIER': {
    color: '#006ED6',
    font: 'white'
  },
  'N/A': {
    color: '#AAAAAA',
    font: 'white'
  }
}

export const chromMap = {
  'chr1': {
    title: '1'
  },
  'chr2': {
    title: '2'
  },
  'chr3': {
    title: '3'
  },
  'chr4': {
    title: '4'
  },
  'chr5': {
    title: '5'
  },
  'chr6': {
    title: '6'
  },
  'chr7': {
    title: '7'
  },
  'chr8': {
    title: '8'
  },
  'chr9': {
    title: '9'
  },
  'chr10': {
    title: '10'
  },
  'chr11': {
    title: '11'
  },
  'chr12': {
    title: '12'
  },
  'chr13': {
    title: '13'
  },
  'chr14': {
    title: '14'
  },
  'chr15': {
    title: '15'
  },
  'chr16': {
    title: '16'
  },
  'chr17': {
    title: '17'
  },
  'chr18': {
    title: '18'
  },
  'chr19': {
    title: '19'
  },
  'chr20': {
    title: '20'
  },
  'chr21': {
    title: '21'
  },
  'chr22': {
    title: '22'
  },
  'chrX': {
    title: 'X'
  },
  'chrY': {
    title: 'Y'
  },
  'chrM': {
    title: 'M'
  }
}

export const caseDataTypeMetadatas = {
  'intractable_disease': {
    sortOption: {
      key: 'Gene_Variant_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'intractable_disease',
        'designated_intractable_disease'
      ],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___intractableDisease'
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => Object.keys((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}),
    variantFilter: (symbol, gene, caseData, project, mode) => Object.entries(gene.variants || {}).filter(([_, variant]) => {
      return variant.Mendelian === undefined || variant.Mendelian === mode['mendelian']
    }).map(([vkey]) => vkey)
  },
  'designated_intractable_disease': {
    sortOption: {
      key: 'Gene_Variant_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'intractable_disease',
        'designated_intractable_disease'
      ],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___designatedIntractableDisease'
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => Object.keys((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}),
    variantFilter: (symbol, gene, caseData, project, mode) => Object.entries(gene.variants || {}).filter(([_, variant]) => {
      return variant.Mendelian === undefined || variant.Mendelian === mode['mendelian']
    }).map(([vkey]) => vkey)
  },
  'pgp': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'pgp',
        'gene_filter'
      ],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___pgp'
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => Object.keys((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}),
    variantFilter: (symbol, gene, caseData, project, mode) => Object.entries(gene.variants || {}).filter(([_, variant]) => {
      return variant.Mendelian === undefined || variant.Mendelian === mode['mendelian']
    }).map(([vkey]) => vkey)
  },
  'gene_filter': {
    sortOption: {
      key: 'Gene_Variant_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'pgp',
        'gene_filter'
      ],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___gene_filter'
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => Object.keys((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}),
    variantFilter: (symbol, gene, caseData, project, mode) => Object.entries(gene.variants || {}).filter(([_, variant]) => {
      return variant.Mendelian === undefined || variant.Mendelian === mode['mendelian']
    }).map(([vkey]) => vkey)
  },
  'str': {
    sortOption: {
      key: data => Math.max(...Array.prototype.concat.apply([], Object.values(data.variants || {}).map(variant => Object.values(variant.Diseases || {}).map(diseases => (diseases.highlight_gene || 0) - -(1 / (1 - -(diseases.allele_score || 0))))))),
      order: 'desc'
    },
    tagOption: {
      groups: [],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___str'
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => Object.keys((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}),
    variantFilter: (symbol, gene, caseData, project, mode) => Object.keys(gene.variants || {})
  },
  'nbs_pathovar': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'nbs_pathovar',
        'nbs_nullvar',
        'nbs_carrier',
        'incidental'
      ],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___nbs_pathovar'
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => {
      let phenotypes = (!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}
      return Object.entries(phenotypes).some(([_, phenotype]) => {
        return phenotype.disease_score !== -1
      }) ? Object.keys(phenotypes) : null
    },
    variantFilter: (symbol, gene, caseData, project, mode) => Object.keys(gene.variants || {})
  },
  'nbs_nullvar': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'nbs_pathovar',
        'nbs_nullvar',
        'nbs_carrier',
        'incidental'
      ],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___nbs_nullvar'
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => {
      let phenotypes = (!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}
      return Object.entries(phenotypes).some(([_, phenotype]) => {
        return phenotype.disease_score !== -1
      }) ? Object.keys(phenotypes) : null
    },
    variantFilter: (symbol, gene, caseData, project, mode) => Object.keys(gene.variants || {})
  },
  'nbs_carrier': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'nbs_pathovar',
        'nbs_nullvar',
        'nbs_carrier',
        'incidental'
      ],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___nbs_carrier'
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => Object.keys((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}),
    variantFilter: (symbol, gene, caseData, project, mode) => Object.keys(gene.variants || {})
  },
  'incidental': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'nbs_pathovar',
        'nbs_nullvar',
        'nbs_carrier',
        'incidental'
      ],
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___incidental'
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => Object.keys((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}),
    variantFilter: (symbol, gene, caseData, project, mode) => Object.keys(gene.variants || {})
  },
  'filter': {
    display: false,
    tagOption: {
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___filter'
    }
  },
  // old
  'clinvar': {
    old: true,
    tagOption: {
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___clinvar'
    }
  },
  'nbs': {
    old: true,
    tagOption: {
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___nbs'
    }
  },
  'nbs_nonmendelian': {
    old: true,
    tagOption: {
      title: 'CONSTANT.global.data.caseDataTypeMetadatas.tag.title.___nbs_nonmendelian'
    }
  }
}

export const caseDataTagOptions = {
  'intractable_disease': {
    background: '#FA3D3D',
    color: 'white'
  },
  'designated_intractable_disease': {
    background: '#F7D1D1',
    color: '#FA3D3D'
  },
  'pgp': {
    background: '#003679',
    color: 'white'
  },
  'gene_filter': {
    background: '#006ED6',
    color: 'white'
  },
  'nbs_pathovar': {
    background: '#B2D3F2',
    color: '#003679'
  },
  'nbs_nullvar': {
    background: '#B2D3F2',
    color: '#003679'
  },
  'nbs_nonmendelian': {
    background: '#B2D3F2',
    color: '#003679'
  },
  'nbs_carrier': {
    background: '#B2D3F2',
    color: '#003679'
  },
  'incidental': {
    background: '#B2D3F2',
    color: '#003679'
  },
  'filter': {
    background: '#B2D3F2',
    color: '#003679'
  },
  'project': {
    background: '#FF9E03',
    color: 'white'
  },
  // old
  'nbs': {
    background: '#B2D3F2',
    color: '#003679'
  }
}

export const predictionMetaDataDisplayTitles = {
  Damaging: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Damaging',
  Tolerated: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Tolerated',
  ProbablyDamaging: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___ProbablyDamaging',
  PossiblyDamaging: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___PossiblyDamaging',
  Benign: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Benign',
  High: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___High',
  Medium: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Medium',
  Low: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Low',
  Neutral: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Neutral',
  Splicealtering: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Splicealtering',
  Conserved: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Conserved',
  Nonconserved: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Nonconserved',
  Likelyorpossiblypathogenic: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Likelyorpossiblypathogenic',
  Likelyorpossiblybenign: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Likelyorpossiblybenign',
  ambiguous: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Ambiguous',
  likely_benign: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___Likelybenign',
  likely_pathogenic: 'CONSTANT.global.data.predictionMetaDataDisplayTitles.___LikelyPathogenic'
}

export const predictionMetaDatas = {
  'Alphamissense': {
    key: {
      score: 'Alphamissense_score',
      pred: 'Alphamissense_class'
    },
    displayMap: {
      'ambiguous': predictionMetaDataDisplayTitles['ambiguous'],
      'likely_benign': predictionMetaDataDisplayTitles['likely_benign'],
      'likely_pathogenic': predictionMetaDataDisplayTitles['likely_pathogenic']
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 0.567) : undefined
  },
  'SIFT4G': {
    key: {
      score: 'SIFT4G_score',
      pred: 'SIFT4G_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: (score, pred) => ({
      'D': false,
      'T': true
    }[pred])
  },
  'Polyphen': {
    key: {
      score: 'Polyphen',
      pred: 'Polyphen_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['ProbablyDamaging'],
      'P': predictionMetaDataDisplayTitles['PossiblyDamaging'],
      'B': predictionMetaDataDisplayTitles['Benign']
    },
    checkPassed: (score, pred) => ({
      'D': false,
      'P': false,
      'B': true
    }[pred])
  },
  'FATHMM': {
    key: {
      score: 'FATHMM_score',
      pred: 'FATHMM_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: (score, pred) => ({
      'D': false,
      'T': true
    }[pred])
  },
  'MutationAssessor': {
    key: {
      score: 'MutationAssessor_score',
      pred: 'MutationAssessor_pred'
    },
    displayMap: {
      'H': predictionMetaDataDisplayTitles['High'],
      'M': predictionMetaDataDisplayTitles['Medium'],
      'L': predictionMetaDataDisplayTitles['Low'],
      'N': predictionMetaDataDisplayTitles['Neutral']
    },
    checkPassed: (score, pred) => ({
      'H': false,
      'M': false,
      'L': true,
      'N': true
    }[pred])
  },
  'PROVEAN': {
    key: {
      score: 'PROVEAN_score',
      pred: 'PROVEAN_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'N': predictionMetaDataDisplayTitles['Neutral']
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 0.7) : undefined
  },
  'CADD_phred': {
    key: {
      score: 'CADD_phred',
      pred: 'CADD_phred_pred'
    },
    displayMap: {
      'red': predictionMetaDataDisplayTitles['Damaging'],
      'black': predictionMetaDataDisplayTitles['Neutral']
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 30) : undefined
  },
  'M_CAP': {
    key: {
      score: 'M_CAP_score',
      pred: 'M_CAP_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 0.025) : undefined
  },
  'MetaLR': {
    key: {
      score: 'MetaLR_score',
      pred: 'MetaLR_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: (score, pred) => ({
      'D': false,
      'T': true
    }[pred])
  },
  'MetaSVM': {
    key: {
      score: 'MetaSVM_score',
      pred: 'MetaSVM_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: (score, pred) => ({
      'D': false,
      'T': true
    }[pred])
  },
  'REVEL': {
    key: {
      score: 'REVEL_score',
      pred: 'REVEL_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 0.7) : undefined
  },
  'BayesDel_noAF': {
    key: {
      score: 'BayesDel_noAF_score',
      pred: 'BayesDel_noAF_pred'
    },
    displayMap: {
      'D': predictionMetaDataDisplayTitles['Damaging'],
      'T': predictionMetaDataDisplayTitles['Tolerated']
    },
    checkPassed: (score, pred) => ({
      'D': false,
      'T': true
    }[pred])
  },
  'ada': {
    key: {
      score: 'ada_score',
      pred: 'ada_pred'
    },
    displayMap: {
      'red': predictionMetaDataDisplayTitles['Splicealtering'],
      'black': predictionMetaDataDisplayTitles['Neutral']
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 0.6) : undefined
  },
  'rf': {
    key: {
      score: 'rf_score',
      pred: 'rf_pred'
    },
    displayMap: {
      'red': predictionMetaDataDisplayTitles['Splicealtering'],
      'black': predictionMetaDataDisplayTitles['Neutral']
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 0.6) : undefined
  },
  'GERPpp_NR': {
    key: {
      score: 'GERPpp_NR',
      pred: 'GERPpp_NR_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'GERPpp_RS': {
    key: {
      score: 'GERPpp_RS',
      pred: 'GERPpp_RS_pred'
    },
    displayMap: {
      'red': predictionMetaDataDisplayTitles['Conserved'],
      'black': predictionMetaDataDisplayTitles['Nonconserved']
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 2) : undefined
  },
  'SiPhy_29way_logOdds': {
    key: {
      score: 'SiPhy_29way_logOdds',
      pred: 'SiPhy_29way_logOdds_pred'
    },
    displayMap: {
      'red': predictionMetaDataDisplayTitles['Conserved'],
      'black': predictionMetaDataDisplayTitles['Nonconserved']
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 12.17) : undefined
  },
  'SiPhy_29way_pi': {
    key: {
      score: 'SiPhy_29way_pi',
      pred: 'SiPhy_29way_pi_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'gnomAD_g_mt_mitotip': {
    key: {
      score: 'gnomAD_g_mt_mitotip_score',
      pred: 'gnomAD_g_mt_mitotip_score_pred'
    },
    displayMap: {
      'red': predictionMetaDataDisplayTitles['Likelyorpossiblypathogenic'],
      'black': predictionMetaDataDisplayTitles['Likelyorpossiblybenign']
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 12.66) : undefined
  },
  'CI_SpliceAI_DS_AG': {
    key: {
      score: 'CI_SpliceAI_DS_AG',
      pred: 'CI_SpliceAI_DS_AG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 0.5) : undefined
  },
  'CI_SpliceAI_DS_AL': {
    key: {
      score: 'CI_SpliceAI_DS_AL',
      pred: 'CI_SpliceAI_DS_AL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 0.5) : undefined
  },
  'CI_SpliceAI_DS_DG': {
    key: {
      score: 'CI_SpliceAI_DS_DG',
      pred: 'CI_SpliceAI_DS_DG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 0.5) : undefined
  },
  'CI_SpliceAI_DS_DL': {
    key: {
      score: 'CI_SpliceAI_DS_DL',
      pred: 'CI_SpliceAI_DS_DL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 0.5) : undefined
  },
  'CI_SpliceAI_DP_AG': {
    key: {
      score: 'CI_SpliceAI_DP_AG',
      pred: 'CI_SpliceAI_DP_AG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'CI_SpliceAI_DP_AL': {
    key: {
      score: 'CI_SpliceAI_DP_AL',
      pred: 'CI_SpliceAI_DP_AL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'CI_SpliceAI_DP_DG': {
    key: {
      score: 'CI_SpliceAI_DP_DG',
      pred: 'CI_SpliceAI_DP_DG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'CI_SpliceAI_DP_DL': {
    key: {
      score: 'CI_SpliceAI_DP_DL',
      pred: 'CI_SpliceAI_DP_DL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'SpliceAI_DS_AG': {
    key: {
      score: 'SpliceAI_DS_AG',
      pred: 'SpliceAI_DS_AG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 0.5) : undefined
  },
  'SpliceAI_DS_AL': {
    key: {
      score: 'SpliceAI_DS_AL',
      pred: 'SpliceAI_DS_AL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 0.5) : undefined
  },
  'SpliceAI_DS_DG': {
    key: {
      score: 'SpliceAI_DS_DG',
      pred: 'SpliceAI_DS_DG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 0.5) : undefined
  },
  'SpliceAI_DS_DL': {
    key: {
      score: 'SpliceAI_DS_DL',
      pred: 'SpliceAI_DS_DL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 0.5) : undefined
  },
  'SpliceAI_DP_AG': {
    key: {
      score: 'SpliceAI_DP_AG',
      pred: 'SpliceAI_DP_AG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'SpliceAI_DP_AL': {
    key: {
      score: 'SpliceAI_DP_AL',
      pred: 'SpliceAI_DP_AL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'SpliceAI_DP_DG': {
    key: {
      score: 'SpliceAI_DP_DG',
      pred: 'SpliceAI_DP_DG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'SpliceAI_DP_DL': {
    key: {
      score: 'SpliceAI_DP_DL',
      pred: 'SpliceAI_DP_DL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'oe_syn': {
    key: {
      score: 'oe_syn',
      pred: 'oe_syn_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'oe_mis': {
    key: {
      score: 'oe_mis',
      pred: 'oe_mis_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'oe_lof': {
    key: {
      score: 'oe_lof',
      pred: 'oe_lof_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'syn_z': {
    key: {
      score: 'syn_z',
      pred: 'syn_z_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'mis_z': {
    key: {
      score: 'mis_z',
      pred: 'mis_z_pred'
    },
    displayMap: {},
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 3.09) : undefined
  },
  'pLI': {
    key: {
      score: 'pLI',
      pred: 'pLI_pred'
    },
    displayMap: {},
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 0.9) : undefined
  }
}

export const omimPhenotypeIDList = [
  '300100',
  '611788',
  '612098',
  '600376',
  '175100',
  '144010',
  '277900',
  '613881',
  '612954',
  '174900',
  '604370',
  '612555',
  '253260',
  '601887',
  '616247',
  '614916',
  '616249',
  '618782',
  '611938',
  '130050',
  '213700',
  '604765',
  '601419',
  '610476',
  '610193',
  '607450',
  '615821',
  '187300',
  '154700',
  '617047',
  '609524',
  '232300',
  '301500',
  '235200',
  '600496',
  '613688',
  '192500',
  '143890',
  '115200',
  '171300',
  '131100',
  '609310',
  '120435',
  '614350',
  '608456',
  '115197',
  '132900',
  '192600',
  '613426',
  '608758',
  '608751',
  '101000',
  '311250',
  '114480',
  '603776',
  '609040',
  '609909',
  '614337',
  '600858',
  '158350',
  '180200',
  '613172',
  '155240',
  '171400',
  '162300',
  '204100',
  '145600',
  '604772',
  '603830',
  '601144',
  '601154',
  '601650',
  '115310',
  '605373',
  '168000',
  '613795',
  '175050',
  '175200',
  '609192',
  '610168',
  '604400',
  '611879',
  '613690',
  '601494',
  '115195',
  '151623',
  '115196',
  '615441',
  '191100',
  '613254',
  '604145',
  '613794'
]

export const getGeneEntriesConditionData = (condition = {}) => {
  const types = ['disease_term', 'mondo', 'orphanet']
  return {
    data: condition.data || Array.prototype.concat.apply([], types.map(type => (condition[type] || { data: [] }).data.map(data => ({ ...data, condition_type: type }))))
  }
}

export const getPhenotypeList = values => {
  let phenotypes = values ? sortData(Array.prototype.concat.apply([], Object.entries(values).map(([id, phenotype]) => {
    let length = !phenotype.Phenotype ? 0 : phenotype.Phenotype instanceof Array ? phenotype.Phenotype.length : 1
    let isArray = phenotype.Phenotype instanceof Array
    return (new Array(length)).fill('').map((_, i) => ({
      ...phenotype,
      id: id,
      index: i,
      Orpha_id: (isArray && phenotype.Orpha_id) ? phenotype.Orpha_id[i] : phenotype.Orpha_id,
      Inheritance: isArray ? (phenotype.Inheritance[i] || '').split(',') : phenotype.Inheritance instanceof Array ? phenotype.Inheritance : [phenotype.Inheritance],
      Phenotype: isArray ? phenotype.Phenotype[i] : phenotype.Phenotype
    }))
  })), 'disease_score', 'desc') : []
  return phenotypes
}

export const getOrphaPhenotypeList = values => {
  let phenotypes = values ? sortData(Array.prototype.concat.apply([], Object.entries(values).map(([id, phenotype]) => {
    let length = !phenotype.disease ? 0 : phenotype.disease instanceof Array ? phenotype.disease.length : 1
    let isArray = phenotype.disease instanceof Array
    return (new Array(length)).fill('').map((_, i) => ({
      ...phenotype,
      id: id,
      index: i,
      inheritance: isArray ? (phenotype.inheritance[i] || '').split(',') : phenotype.inheritance instanceof Array ? phenotype.inheritance : [phenotype.inheritance],
      disease: isArray ? phenotype.disease[i] : phenotype.disease
    }))
  })), 'disease_score', 'desc') : []
  return phenotypes
}

export const getSTRPhenotypeList = variants => {
  let phenotypes = Object.values(variants || {}).reduce((phenotypes, variant) => {
    let results = Object.entries(variant.Diseases || {}).map(([key, data]) => ({ ...data, Phenotype: key, Inheritance: (data.Inheritance || '').split(',') }))
    return [
      ...phenotypes,
      ...results
    ]
  }, [])
  return phenotypes
}

export const getRegionPhenotypeList = regionData => {
  if (!regionData.Phenotype_MIM_number) return []
  let ids = (regionData.Phenotype_MIM_number || '').split('|')
  let phenotypes = (regionData.Phenotype || '').split('|')
  let inheritances = (regionData.Inheritance || '').split('|')
  let orphaIDs = (regionData.at_orpha_id || '').split('|')
  return ids.map((id, i) => ({
    id: id,
    index: i,
    Orpha_id: orphaIDs[i],
    Inheritance: inheritances[i] ? inheritances[i].split(',') : [],
    Phenotype: phenotypes[i]
  }))
}

export const getRegionOrphaPhenotypeList = regionData => {
  if (!regionData.at_orpha_id && !regionData.mt_orpha_id) return []
  let ids = (regionData.at_orpha_id || regionData.mt_orpha_id || '').split('|')
  let diseases = (regionData.orphanet_disease || '').split('|')
  let inheritances = (regionData.orphanet_inheritance || '').split('|')
  return ids.map((id, i) => ({
    id: id,
    index: i,
    inheritance: inheritances[i] ? inheritances[i].split(',') : [],
    disease: diseases[i]
  }))
}

export const getClinvarACMGMapDatas = (values, type = 'default') => {
  let ary = values ? values.split(/,|\||\//).map(value => (value || 'N/A').replace(/_/g, ' ').trim()) : ['N/A']
  let map = {
    default: clinvarACMGMap,
    report: clinvarACMGMap
  }[type]
  let datas = sortData(ary.map(value => (map[value] ? {
    ...map[value],
    display_zh: reportClinvarACMGZHMap[value]
  } : {
    display: value,
    title: value,
    color: '#AAAAAA',
    index: -1
  })), data => data.index, 'desc')
  return datas
}

export const getClinvarStatisticData = clinvarStatistic => {
  const defaultDataGenerator = () => ({
    n: 0
  })
  const tableTitles = {
    title: 'CONSTANT.global.data.getClinvarStatisticData.___title',
    Pathogenic: 'CONSTANT.global.data.getClinvarStatisticData.___Pathogenic',
    Likely_pathogenic: 'CONSTANT.global.data.getClinvarStatisticData.___Likely_pathogenic',
    Conflicting_interpretations_of_pathogenicity: 'CONSTANT.global.data.getClinvarStatisticData.___Conflicting_interpretations_of_pathogenicity',
    Uncertain_significance: 'CONSTANT.global.data.getClinvarStatisticData.___Uncertain_significance',
    Likely_benign: 'CONSTANT.global.data.getClinvarStatisticData.___Likely_benign',
    Benign: 'CONSTANT.global.data.getClinvarStatisticData.___Benign',
    stop_gained: 'CONSTANT.global.data.getClinvarStatisticData.___stop_gained',
    splice_site: 'CONSTANT.global.data.getClinvarStatisticData.___splice_site',
    frameshift: 'CONSTANT.global.data.getClinvarStatisticData.___frameshift',
    stop_lost: 'CONSTANT.global.data.getClinvarStatisticData.___stop_lost',
    start_lost: 'CONSTANT.global.data.getClinvarStatisticData.___start_lost',
    missense: 'CONSTANT.global.data.getClinvarStatisticData.___missense',
    inframe_indel: 'CONSTANT.global.data.getClinvarStatisticData.___inframe_indel',
    synonymous: 'CONSTANT.global.data.getClinvarStatisticData.___synonymous',
    non_coding: 'CONSTANT.global.data.getClinvarStatisticData.___non_coding',
    total: 'CONSTANT.global.data.getClinvarStatisticData.___total'
  }
  const defaultTableConfig = {
    'gs': {
      'title': {
        data: false,
        title: [
          tableTitles['title']
        ].join(' ')/* ___ */,
        flex: 146,
        color: '#FFFFFF'
      },
      'Pathogenic': {
        title: [
          tableTitles['Pathogenic']
        ].join(' ')/* ___ */,
        flex: 135,
        color: '#FA3D3D'
      },
      'Likely_pathogenic': {
        title: [
          tableTitles['Likely_pathogenic']
        ].join(' ')/* ___ */,
        flex: 135,
        color: '#FF9E03'
      },
      'Conflicting_interpretations_of_pathogenicity': {
        title: [
          tableTitles['Conflicting_interpretations_of_pathogenicity']
        ].join(' ')/* ___ */,
        flex: 210,
        color: '#999999'
      },
      'Uncertain_significance': {
        title: [
          tableTitles['Uncertain_significance']
        ].join(' ')/* ___ */,
        flex: 135,
        color: '#F8C600'
      },
      'Likely_benign': {
        title: [
          tableTitles['Likely_benign']
        ].join(' ')/* ___ */,
        flex: 135,
        color: '#83C91E'
      },
      'Benign': {
        title: [
          tableTitles['Benign']
        ].join(' ')/* ___ */,
        flex: 135,
        color: '#349CCF'
      },
      'total': {
        data: false,
        title: [
          tableTitles['total']
        ].join(' ')/* ___ */,
        flex: 135,
        color: '#FFFFFF'
      }
    },
    'csq': {
      'title': {
        data: false,
        title: [
          tableTitles['title']
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'stop_gained': {
        title: [
          tableTitles['stop_gained']
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'splice_site': {
        title: [
          tableTitles['splice_site']
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'frameshift': {
        title: [
          tableTitles['frameshift']
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'stop_lost': {
        title: [
          tableTitles['stop_lost']
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'start_lost': {
        title: [
          tableTitles['start_lost']
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'missense': {
        title: [
          tableTitles['missense']
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'inframe_indel': {
        title: [
          tableTitles['inframe_indel']
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'synonymous': {
        title: [
          tableTitles['synonymous']
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'non_coding': {
        title: [
          tableTitles['non_coding']
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'total': {
        data: false,
        title: [
          tableTitles['total']
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      }
    }
  }
  let clinvarTableData = {}
  clinvarTableData['function'] = {
    getOpacity: p => {
      if (p === 0) return '00'
      else if (p < 0.02) return '02'
      else if (p <= 0.1) return '10'
      else if (p <= 0.2) return '20'
      else if (p <= 0.3) return '30'
      else if (p <= 0.4) return '40'
      else if (p <= 0.5) return '50'
      else if (p <= 0.6) return '60'
      else if (p <= 0.7) return '70'
      else if (p <= 0.8) return '80'
      else if (p <= 0.9) return '90'
      else return ''
    }
  }
  clinvarTableData['config'] = defaultTableConfig
  clinvarTableData['data'] = {
    gs: {
      ...Object.entries(defaultTableConfig['gs']).filter(([_, value]) => value.data !== false).reduce((r, [key]) => ({
        ...r,
        [key]: {
          ...Object.entries(defaultTableConfig['csq']).filter(([_, value]) => value.data !== false).reduce((r, [key]) => ({
            ...r,
            [key]: defaultDataGenerator()
          }), {}),
          total: 0
        }
      }), {}),
      total: 0
    },
    csq: {
      ...Object.entries(defaultTableConfig['csq']).filter(([_, value]) => value.data !== false).reduce((r, [key]) => ({
        ...r,
        [key]: {
          ...Object.entries(defaultTableConfig['gs']).filter(([_, value]) => value.data !== false).reduce((r, [key]) => ({
            ...r,
            [key]: defaultDataGenerator()
          }), {}),
          total: 0
        }
      }), {}),
      total: 0
    }
  }
  for (let data of clinvarStatistic) {
    let keys = {
      gs_clinsig: data.gs_clinsig.replace(/_variant$/, ''),
      csq: data.csq.replace(/_variant$/, '')
    }
    clinvarTableData['data']['gs'].total += data.n
    clinvarTableData['data']['gs'][keys.gs_clinsig].total += data.n
    clinvarTableData['data']['gs'][keys.gs_clinsig][keys.csq].n += data.n
    clinvarTableData['data']['csq'].total += data.n
    clinvarTableData['data']['csq'][keys.csq].total += data.n
    clinvarTableData['data']['csq'][keys.csq][keys.gs_clinsig].n += data.n
  }
  return clinvarTableData
}

export const clinvarACMGMap = {
  'Pathogenic': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Pathogenic',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Pathogenic',
    color: '#FA3D3D',
    index: 12
  },
  'Pathogenic/Likely pathogenic': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___PathogenicLikelypathogenic',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___PathogenicLikelypathogenic',
    color: '#FF9E03',
    index: 5
  },
  'Likely pathogenic': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Likelypathogenic',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Likelypathogenic',
    color: '#FF9E03',
    index: 11
  },
  'Conflicting interpretations of pathogenicity': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Conflictinginterpretationsofpathogenicity',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Conflictinginterpretationsofpathogenicity',
    color: '#F8C600',
    index: 10
  },
  'Conflicting classifications of pathogenicity': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Conflictingclassificationsofpathogenicity',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Conflictingclassificationsofpathogenicity',
    color: '#F8C600',
    index: 10
  },
  'Uncertain significance': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Uncertainsignificance',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Uncertainsignificance',
    color: '#F8C600',
    index: 9
  },
  'risk factor': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___riskfactor',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___riskfactor',
    color: '#FF0000',
    index: 8
  },
  'Benign': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Benign',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Benign',
    color: '#006ED6',
    index: 6
  },
  'Benign/Likely benign': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___BenignLikelybenign',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___BenignLikelybenign',
    color: '#83C91E',
    index: 4
  },
  'Likely benign': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Likelybenign',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Likelybenign',
    color: '#83C91E',
    index: 7
  },
  'drug response': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___drugresponse',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___drugresponse',
    color: '#F8C600',
    index: 3
  },
  'protective': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___protective',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___protective',
    color: '#F8C600',
    index: 2
  },
  'other': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___other',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___other',
    color: '#333333',
    index: 1
  },
  'Affects': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___Affects',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___Affects',
    color: '#333333',
    index: 1
  },
  'vus': {
    display: 'CONSTANT.global.data.clinvarACMGMap.title.___vus',
    title: 'CONSTANT.global.data.clinvarACMGMap.display.___vus',
    color: '#333333',
    index: 1
  },
  'N/A': {
    display: defaultEmptyDisplay.empty,
    title: defaultEmptyDisplay.empty,
    color: '#AAAAAA',
    index: 0
  }
}

export const repeatClassificationMap = {
  'Pathogenic': {
    title: 'CONSTANT.global.data.repeatClassificationMap.title.___Pathogenic',
    color: '#FA3D3D'
  },
  'Indeterminate': {
    title: 'CONSTANT.global.data.repeatClassificationMap.title.___Indeterminate',
    color: '#F8C600'
  },
  'Intermediate': {
    title: 'CONSTANT.global.data.repeatClassificationMap.title.___Intermediate',
    color: '#FF9E03'
  },
  'Normal': {
    title: 'CONSTANT.global.data.repeatClassificationMap.title.___Normal',
    color: '#349CCF'
  }
}

export const reportGTMap = {
  'heterozygous': 'hetero<br>(雜合子)',
  'homozygous': 'homo<br>(純合子)',
  'hemizygous': 'hemi<br>(半合子)',
  'heterozygote': 'hetero<br>(雜合子)',
  'homozygote': 'homo<br>(純合子)',
  'hemizygote': 'hemi<br>(半合子)'
}

export const reportEnGTMap = {
  'heterozygous': 'hetero',
  'homozygous': 'homo',
  'hemizygous': 'hemi',
  'heterozygote': 'hetero',
  'homozygote': 'homo',
  'hemizygote': 'hemi'
}

export const reportClinvarACMGZHMap = {
  'Benign': '良性的',
  'Benign/Likely benign': '良性的/可能良性的',
  'Conflicting interpretations of pathogenicity': '致病性意義衝突',
  'Likely benign': '可能良性的',
  'drug response': '藥物反應',
  'risk factor': '風險因子',
  'protective': '有保護性的',
  'Uncertain significance': '不明確的',
  'Pathogenic': '致病的',
  'other': '其他',
  'Likely pathogenic': '可能致病的',
  'Pathogenic/Likely pathogenic': '致病的/可能致病的',
  'Affects': '非疾病相關表徵反應'
}

export const reportCNVTypeMap = {
  'deletion': 'Deletion',
  'duplication': 'Duplication',
  'insertion': 'Insertion',
  'inversion': 'Inversion',
  'translocation': 'Translocation',
  'complex_sv': 'Complex SV'
}

export const reportParentalOriginMap = {
  'De Novo': 'De Novo',
  'Paternal': 'Paternal',
  'Maternal': 'Maternal',
  'Biparental': 'Biparental',
  'Unknown': 'Unknown'
}

export const acmgMap = {
  // BA
  BA1: {
    title: 'BA1',
    type: 'Strong',
    class: 'benign-strong',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___BA1'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___BA1'
    ]
  },
  // BS
  BS1: {
    title: 'BS1',
    type: 'Strong',
    class: 'benign-strong',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___BS1'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___BS1'
    ]
  },
  BS2: {
    title: 'BS2',
    type: 'Strong',
    class: 'benign-strong',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___BS2'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___BS2'
    ]
  },
  BS4: {
    title: 'BS4',
    type: 'Strong',
    class: 'benign-strong',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___BS4'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___BS4'
    ]
  },
  BS3: {
    title: 'BS3',
    type: 'Strong',
    class: 'benign-strong',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___BS3'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___BS3'
    ]
  },
  // BP
  BP2: {
    title: 'BP2',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___BP2'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___BP2'
    ]
  },
  BP5: {
    title: 'BP5',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___BP5'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___BP5'
    ]
  },
  BP1: {
    title: 'BP1',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___BP1'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___BP1'
    ]
  },
  BP3: {
    title: 'BP3',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___BP3'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___BP3'
    ]
  },
  BP4: {
    title: 'BP4',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___BP4'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___BP4'
    ]
  },
  BP7: {
    title: 'BP7',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___BP7'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___BP7'
    ]
  },
  BP6: {
    title: 'BP6',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___BP6'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___BP6'
    ]
  },
  // PP
  PP1: {
    title: 'PP1',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PP1'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PP1'
    ]
  },
  PP2: {
    title: 'PP2',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PP2'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PP2'
    ]
  },
  PP3: {
    title: 'PP3',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PP3'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PP3'
    ]
  },
  PP4: {
    title: 'PP4',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PP4'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PP4'
    ]
  },
  PP5: {
    title: 'PP5',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PP5'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PP5'
    ]
  },
  // PM
  PM2: {
    title: 'PM2',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PM2'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PM2'
    ]
  },
  PM3: {
    title: 'PM3',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PM3'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PM3'
    ]
  },
  PM6: {
    title: 'PM6',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PM6'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PM6'
    ]
  },
  PM1: {
    title: 'PM1',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PM1'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PM1'
    ]
  },
  PM4: {
    title: 'PM4',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PM4'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PM4'
    ]
  },
  PM5: {
    title: 'PM5',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PM5'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PM5'
    ]
  },
  // PS
  PS4: {
    title: 'PS4',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PS4'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PS4'
    ]
  },
  PS2: {
    title: 'PS2',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PS2'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PS2'
    ]
  },
  PS1: {
    title: 'PS1',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PS1'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PS1'
    ]
  },
  PS3: {
    title: 'PS3',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PS3'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PS3'
    ]
  },
  // PVS
  PVS1: {
    title: 'PVS1',
    type: 'Very Strong',
    class: 'pathogenic-very-strong',
    informations: [
      'CONSTANT.global.data.acmgMap.info.___PVS1'
    ],
    explanations: [
      'CONSTANT.global.data.acmgMap.explanations.___PVS1'
    ]
  }
}

export const reportPreviewRangeData = {
  'ps': [1, 5],
  'pd': [3, Number.MAX_VALUE]
}

export const reportPreviewDefaultDatas = {
  'select': {
    'ps': [
      'SIFT4G_score',
      'Polyphen',
      'CADD_phred',
      'REVEL_score',
      'BayesDel_noAF_score'
    ],
    'pd': [
      'KG_EAS_AF',
      'gnomAD_EAS_AF',
      'TW_AF'
    ]
  },
  'display': {
    'default': [
      'gnomAD_AF',
      'gnomAD_g_AF'
    ],
    'us': [
      'gnomAD_AF',
      'gnomAD_g_AF'
    ],
    'jp': [
      'tommo_60kjpn_AF',
      'gnomAD_g_AF'
    ]
  }[_WEBSITE_VERSION] || [
    'gnomAD_AF',
    'gnomAD_g_AF'
  ]
}

export const getReportPreviewColumns = (columns = [], selectType, dataType) => {
  if (selectType === 'select') {
    let range = reportPreviewRangeData[dataType]
    columns = columns.filter(column => reportPreviewTypeMap[column] === dataType)
    if (dataType === 'pd') {
      return ((columns.length >= range[0]) && (columns.length <= range[1])) ? columns : reportPreviewDefaultDatas['select']['pd']
    } else if (dataType === 'ps') {
      return ((columns.length >= range[0]) && (columns.length <= range[1])) ? columns : reportPreviewDefaultDatas['select']['ps']
    }
  } else if (selectType === 'display') {
    return columns.length ? columns : reportPreviewDefaultDatas['display']
  }
}

export const reportPreviewOptions = {
  'pd': [
    // // Allele Frequency
    // 1000 Genomes
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___KG_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___1000Genomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'KG_AF',
      value: variant => variant.KG_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___KG_EAS_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___1000Genomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'KG_EAS_AF',
      value: variant => variant.KG_EAS_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___KG_AMR_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___1000Genomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'KG_AMR_AF',
      value: variant => variant.KG_AMR_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___KG_AFR_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___1000Genomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'KG_AFR_AF',
      value: variant => variant.KG_AFR_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___KG_EUR_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___1000Genomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'KG_EUR_AF',
      value: variant => variant.KG_EUR_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___KG_SAS_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___1000Genomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'KG_SAS_AF',
      value: variant => variant.KG_SAS_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    // gnomAD Exomes
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_AF',
      value: variant => variant.gnomAD_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_AFR_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_AFR_AF',
      value: variant => variant.gnomAD_AFR_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_AMR_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_AMR_AF',
      value: variant => variant.gnomAD_AMR_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_ASJ_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_ASJ_AF',
      value: variant => variant.gnomAD_ASJ_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_EAS_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_EAS_AF',
      value: variant => variant.gnomAD_EAS_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_FIN_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_FIN_AF',
      value: variant => variant.gnomAD_FIN_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_NFE_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_NFE_AF',
      value: variant => variant.gnomAD_NFE_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_OTH_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_OTH_AF',
      value: variant => variant.gnomAD_OTH_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      // displayForm: true,
      old: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_SAS_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_SAS_AF',
      value: variant => variant.gnomAD_SAS_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_MID_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_MID_AF',
      value: variant => variant.gnomAD_MID_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      displayForm: true
    },
    // gnomAD Genomes
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_AF',
      value: variant => variant.gnomAD_g_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM'),
      resultDisplay: variant => variant.CHROM !== 'chrM',
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_afr',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_AF_afr',
      value: variant => variant.gnomAD_g_AF_afr,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM'),
      resultDisplay: variant => variant.CHROM !== 'chrM',
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_ami',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_AF_ami',
      value: variant => variant.gnomAD_g_AF_ami,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM'),
      resultDisplay: variant => variant.CHROM !== 'chrM',
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_amr',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_AF_amr',
      value: variant => variant.gnomAD_g_AF_amr,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM'),
      resultDisplay: variant => variant.CHROM !== 'chrM',
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_asj',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_AF_asj',
      value: variant => variant.gnomAD_g_AF_asj,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM'),
      resultDisplay: variant => variant.CHROM !== 'chrM',
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_eas',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_AF_eas',
      value: variant => variant.gnomAD_g_AF_eas,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM'),
      resultDisplay: variant => variant.CHROM !== 'chrM',
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_fin',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_AF_fin',
      value: variant => variant.gnomAD_g_AF_fin,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM'),
      resultDisplay: variant => variant.CHROM !== 'chrM',
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_mid',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_AF_mid',
      value: variant => variant.gnomAD_g_AF_mid,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM'),
      resultDisplay: variant => variant.CHROM !== 'chrM',
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_nfe',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_AF_nfe',
      value: variant => variant.gnomAD_g_AF_nfe,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM'),
      resultDisplay: variant => variant.CHROM !== 'chrM',
      displayForm: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_oth',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_AF_oth',
      value: variant => variant.gnomAD_g_AF_oth,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM'),
      resultDisplay: variant => variant.CHROM !== 'chrM',
      // displayForm: true
      old: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_AF_sas',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_AF_sas',
      value: variant => variant.gnomAD_g_AF_sas,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM'),
      resultDisplay: variant => variant.CHROM !== 'chrM',
      displayForm: true
    },
    // gnomAD Genomes MT
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_AF_het',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_AF_het',
      value: variant => variant.gnomAD_g_mt_AF_het,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_afr',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_het_afr',
      value: variant => variant.gnomAD_g_mt_pop_AF_het_afr,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_ami',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_het_ami',
      value: variant => variant.gnomAD_g_mt_pop_AF_het_ami,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_amr',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_het_amr',
      value: variant => variant.gnomAD_g_mt_pop_AF_het_amr,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_asj',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_het_asj',
      value: variant => variant.gnomAD_g_mt_pop_AF_het_asj,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_eas',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_het_eas',
      value: variant => variant.gnomAD_g_mt_pop_AF_het_eas,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_fin',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_het_fin',
      value: variant => variant.gnomAD_g_mt_pop_AF_het_fin,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_mid',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_het_mid',
      value: variant => variant.gnomAD_g_mt_pop_AF_het_mid,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_nfe',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_het_nfe',
      value: variant => variant.gnomAD_g_mt_pop_AF_het_nfe,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_oth',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_het_oth',
      value: variant => variant.gnomAD_g_mt_pop_AF_het_oth,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_het_sas',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_het_sas',
      value: variant => variant.gnomAD_g_mt_pop_AF_het_sas,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_AF_hom',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_AF_hom',
      value: variant => variant.gnomAD_g_mt_AF_hom,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_afr',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_hom_afr',
      value: variant => variant.gnomAD_g_mt_pop_AF_hom_afr,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_ami',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_hom_ami',
      value: variant => variant.gnomAD_g_mt_pop_AF_hom_ami,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_amr',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_hom_amr',
      value: variant => variant.gnomAD_g_mt_pop_AF_hom_amr,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_asj',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_hom_asj',
      value: variant => variant.gnomAD_g_mt_pop_AF_hom_asj,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_eas',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_hom_eas',
      value: variant => variant.gnomAD_g_mt_pop_AF_hom_eas,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_fin',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_hom_fin',
      value: variant => variant.gnomAD_g_mt_pop_AF_hom_fin,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_mid',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_hom_mid',
      value: variant => variant.gnomAD_g_mt_pop_AF_hom_mid,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_nfe',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_hom_nfe',
      value: variant => variant.gnomAD_g_mt_pop_AF_hom_nfe,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_oth',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_hom_oth',
      value: variant => variant.gnomAD_g_mt_pop_AF_hom_oth,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_pop_AF_hom_sas',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_pop_AF_hom_sas',
      value: variant => variant.gnomAD_g_mt_pop_AF_hom_sas,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM'),
      resultDisplay: variant => variant.CHROM === 'chrM'
    },
    // Other
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___ESP6500_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'ESP6500_AF',
      value: variant => variant.ESP6500_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___ESP6500_AA_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'ESP6500_AA_AF',
      value: variant => variant.ESP6500_AA_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___ESP6500_EA_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'ESP6500_EA_AF',
      value: variant => variant.ESP6500_EA_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___TW_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'TW_AF',
      value: variant => variant.TW_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___TOPMED_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'TOPMED_AF',
      value: variant => variant.TOPMED_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      displayForm: true,
      formGroupDisplay: false
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___UK10K_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'UK10K_AF',
      value: variant => variant.UK10K_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      displayForm: true,
      formGroupDisplay: false
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___ChinaMAP_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'ChinaMAP_AF',
      value: variant => variant.ChinaMAP_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      old: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___GA_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'GA_AF',
      value: variant => variant.GA_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___KJ_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'KJ_AF',
      value: variant => variant.KJ_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      old: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___ExAC_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'ExAC_AF',
      value: variant => variant.ExAC_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___tommo_60kjpn_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      displayCategory: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'tommo_60kjpn_AF',
      value: variant => variant.tommo_60kjpn_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      displayForm: true,
      formGroupDisplay: false
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___tommo_60kjpn_AN',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___other',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'tommo_60kjpn_AN',
      value: variant => variant.tommo_60kjpn_AN,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    // PhenoVarDB Private
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_FILTER',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_P_FILTER',
      value: variant => variant.PVDB_P_FILTER,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_F_MISSING',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_P_F_MISSING',
      value: variant => variant.PVDB_P_F_MISSING,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_AC',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_P_AC',
      value: variant => variant.PVDB_P_AC,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_AN',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_P_AN',
      value: variant => variant.PVDB_P_AN,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_P_AF',
      value: variant => variant.PVDB_P_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_DP',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_P_DP',
      value: variant => variant.PVDB_P_DP,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_AC_Het',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_P_AC_Het',
      value: variant => variant.PVDB_P_AC_Het,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      long: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_AC_Hom',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_P_AC_Hom',
      value: variant => variant.PVDB_P_AC_Hom,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      long: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_P_AC_Hemi',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBPrivate',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_P_AC_Hemi',
      value: variant => variant.PVDB_P_AC_Hemi,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      long: true
    },
    // PhenoVarDB Community
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_FILTER',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_S_FILTER',
      value: variant => variant.PVDB_S_FILTER,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_F_MISSING',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_S_F_MISSING',
      value: variant => variant.PVDB_S_F_MISSING,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_AC',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_S_AC',
      value: variant => variant.PVDB_S_AC,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_AN',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_S_AN',
      value: variant => variant.PVDB_S_AN,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_S_AF',
      value: variant => variant.PVDB_S_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_DP',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_S_DP',
      value: variant => variant.PVDB_S_DP,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_AC_Het',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_S_AC_Het',
      value: variant => variant.PVDB_S_AC_Het,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      long: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_AC_Hom',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_S_AC_Hom',
      value: variant => variant.PVDB_S_AC_Hom,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      long: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_S_AC_Hemi',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBCommunity',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_S_AC_Hemi',
      value: variant => variant.PVDB_S_AC_Hemi,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      long: true
    },
    // PhenoVarDB Admin
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_FILTER',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_A_FILTER',
      value: variant => variant.PVDB_A_FILTER,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: (variants, user) => ['supervisor'].includes(user.role),
      resultDisplay: (variant, user) => ['supervisor'].includes(user.role)
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_F_MISSING',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_A_F_MISSING',
      value: variant => variant.PVDB_A_F_MISSING,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: (variants, user) => ['supervisor'].includes(user.role),
      resultDisplay: (variant, user) => ['supervisor'].includes(user.role)
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_AC',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_A_AC',
      value: variant => variant.PVDB_A_AC,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: (variants, user) => ['supervisor'].includes(user.role),
      resultDisplay: (variant, user) => ['supervisor'].includes(user.role)
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_AN',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_A_AN',
      value: variant => variant.PVDB_A_AN,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: (variants, user) => ['supervisor'].includes(user.role),
      resultDisplay: (variant, user) => ['supervisor'].includes(user.role)
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_AF',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_A_AF',
      value: variant => variant.PVDB_A_AF,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: (variants, user) => ['supervisor'].includes(user.role),
      resultDisplay: (variant, user) => ['supervisor'].includes(user.role)
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_DP',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_A_DP',
      value: variant => variant.PVDB_A_DP,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: (variants, user) => ['supervisor'].includes(user.role),
      resultDisplay: (variant, user) => ['supervisor'].includes(user.role)
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_AC_Het',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_A_AC_Het',
      value: variant => variant.PVDB_A_AC_Het,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: (variants, user) => ['supervisor'].includes(user.role),
      resultDisplay: (variant, user) => ['supervisor'].includes(user.role),
      long: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_AC_Hom',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_A_AC_Hom',
      value: variant => variant.PVDB_A_AC_Hom,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: (variants, user) => ['supervisor'].includes(user.role),
      resultDisplay: (variant, user) => ['supervisor'].includes(user.role),
      long: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PVDB_A_AC_Hemi',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___phenoVarDBAdmin',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___AlleleFrequency',
      resultCategory: '__DEFAULT',
      key: 'PVDB_A_AC_Hemi',
      value: variant => variant.PVDB_A_AC_Hemi,
      class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
      selectDisplay: (variants, user) => ['supervisor'].includes(user.role),
      resultDisplay: (variant, user) => ['supervisor'].includes(user.role),
      long: true
    },
    // // Coverage
    // gnomAD Exomes
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_cov_MEAN',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___coverageGnomADExomes',
      filterGroup: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___coverage',
      key: 'gnomAD_cov_MEAN',
      value: variant => variant.gnomAD_cov_MEAN,
      class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_cov_MEDIAN',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___coverageGnomADExomes',
      filterGroup: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___coverage',
      key: 'gnomAD_cov_MEDIAN',
      value: variant => variant.gnomAD_cov_MEDIAN,
      class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_cov_PCT_20X',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___coverageGnomADExomes',
      filterGroup: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADExomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___coverage',
      key: 'gnomAD_cov_PCT_20X',
      value: variant => variant.gnomAD_cov_PCT_20X,
      class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    // gnomAD Genomes
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_cov_MEAN',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___coverageGnomADGenomes',
      filterGroup: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___coverage',
      key: 'gnomAD_g_cov_MEAN',
      value: variant => variant.gnomAD_g_cov_MEAN,
      class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_cov_MEDIAN',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___coverageGnomADGenomes',
      filterGroup: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___coverage',
      key: 'gnomAD_g_cov_MEDIAN',
      value: variant => variant.gnomAD_g_cov_MEDIAN,
      class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_cov_PCT_20X',
      group: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___coverageGnomADGenomes',
      filterGroup: 'CONSTANT.global.data.reportPreviewOptions.groupTitle.___gnomADGenomes',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___coverage',
      key: 'gnomAD_g_cov_PCT_20X',
      value: variant => variant.gnomAD_g_cov_PCT_20X,
      class: value => (value || value === 0) ? ['normal'] : ['empty']
    }
  ],
  'ps': [
    // // Function Prediction
    // default
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___Alphamissense_score',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'Alphamissense_score',
      value: variant => variant.Alphamissense_score,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['Alphamissense'].checkPassed || (() => true))(variant.Alphamissense_score, variant.Alphamissense_class) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___Alphamissense_class',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'Alphamissense_class',
      value: variant => predictionMetaDatas['Alphamissense'].displayMap[variant.Alphamissense_class] || variant.Alphamissense_class,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['Alphamissense'].checkPassed || (() => true))(variant.Alphamissense_score, variant.Alphamissense_class) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SIFT4G_score',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SIFT4G_score',
      value: variant => ((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_score,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SIFT4G'].checkPassed || (() => true))(((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_score, ((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SIFT4G_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SIFT4G_pred',
      value: variant => predictionMetaDatas['SIFT4G'].displayMap[((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_pred] || ((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SIFT4G'].checkPassed || (() => true))(((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_score, ((variant.transcripts || {})[variant.Feature] || variant).SIFT4G_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___Polyphen',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'Polyphen',
      value: variant => ((variant.transcripts || {})[variant.Feature] || variant).Polyphen,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['Polyphen'].checkPassed || (() => true))(((variant.transcripts || {})[variant.Feature] || variant).Polyphen, ((variant.transcripts || {})[variant.Feature] || variant).Polyphen_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___Polyphen_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'Polyphen_pred',
      value: variant => predictionMetaDatas['Polyphen'].displayMap[((variant.transcripts || {})[variant.Feature] || variant).Polyphen_pred] || ((variant.transcripts || {})[variant.Feature] || variant).Polyphen_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['Polyphen'].checkPassed || (() => true))(((variant.transcripts || {})[variant.Feature] || variant).Polyphen, ((variant.transcripts || {})[variant.Feature] || variant).Polyphen_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___FATHMM_score',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'FATHMM_score',
      value: variant => ((variant.transcripts || {})[variant.Feature] || variant).FATHMM_score,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['FATHMM'].checkPassed || (() => true))(((variant.transcripts || {})[variant.Feature] || variant).FATHMM_score, ((variant.transcripts || {})[variant.Feature] || variant).FATHMM_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___FATHMM_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'FATHMM_pred',
      value: variant => predictionMetaDatas['FATHMM'].displayMap[((variant.transcripts || {})[variant.Feature] || variant).FATHMM_pred] || ((variant.transcripts || {})[variant.Feature] || variant).FATHMM_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['FATHMM'].checkPassed || (() => true))(((variant.transcripts || {})[variant.Feature] || variant).FATHMM_score, ((variant.transcripts || {})[variant.Feature] || variant).FATHMM_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PROVEAN_score',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'PROVEAN_score',
      value: variant => ((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_score,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['PROVEAN'].checkPassed || (() => true))(((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_score, ((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___PROVEAN_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'PROVEAN_pred',
      value: variant => predictionMetaDatas['PROVEAN'].displayMap[((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_pred] || ((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['PROVEAN'].checkPassed || (() => true))(((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_score, ((variant.transcripts || {})[variant.Feature] || variant).PROVEAN_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___CADD_phred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'CADD_phred',
      value: variant => variant.CADD_phred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CADD_phred'].checkPassed || (() => true))(variant.CADD_phred, variant.CADD_phred_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___CADD_phred_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'CADD_phred_pred',
      value: variant => predictionMetaDatas['CADD_phred'].displayMap[variant.CADD_phred_pred] || variant.CADD_phred_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CADD_phred'].checkPassed || (() => true))(variant.CADD_phred, variant.CADD_phred_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___MetaLR_score',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'MetaLR_score',
      value: variant => variant.MetaLR_score,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['MetaLR'].checkPassed || (() => true))(variant.MetaLR_score, variant.MetaLR_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___MetaLR_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'MetaLR_pred',
      value: variant => predictionMetaDatas['MetaLR'].displayMap[variant.MetaLR_pred] || variant.MetaLR_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['MetaLR'].checkPassed || (() => true))(variant.MetaLR_score, variant.MetaLR_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___MetaSVM_score',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'MetaSVM_score',
      value: variant => variant.MetaSVM_score,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['MetaSVM'].checkPassed || (() => true))(variant.MetaSVM_score, variant.MetaSVM_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___MetaSVM_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'MetaSVM_pred',
      value: variant => predictionMetaDatas['MetaSVM'].displayMap[variant.MetaSVM_pred] || variant.MetaSVM_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['MetaSVM'].checkPassed || (() => true))(variant.MetaSVM_score, variant.MetaSVM_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___REVEL_score',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'REVEL_score',
      value: variant => variant.REVEL_score,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['REVEL'].checkPassed || (() => true))(variant.REVEL_score, variant.REVEL_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___REVEL_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'REVEL_pred',
      value: variant => predictionMetaDatas['REVEL'].displayMap[variant.REVEL_pred] || variant.REVEL_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['REVEL'].checkPassed || (() => true))(variant.REVEL_score, variant.REVEL_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty'],
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___BayesDel_noAF_score',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'BayesDel_noAF_score',
      value: variant => variant.BayesDel_noAF_score,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['BayesDel_noAF'].checkPassed || (() => true))(variant.BayesDel_noAF_score, variant.BayesDel_noAF_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___BayesDel_noAF_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psEnsemble',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'BayesDel_noAF_pred',
      value: variant => predictionMetaDatas['BayesDel_noAF'].displayMap[variant.BayesDel_noAF_pred] || variant.BayesDel_noAF_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['BayesDel_noAF'].checkPassed || (() => true))(variant.BayesDel_noAF_score, variant.BayesDel_noAF_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_mitotip_score',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_mitotip_score',
      value: variant => variant.gnomAD_g_mt_mitotip_score,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['gnomAD_g_mt_mitotip'].checkPassed || (() => true))(variant.gnomAD_g_mt_mitotip_score, variant.gnomAD_g_mt_mitotip_score_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___gnomAD_g_mt_mitotip_score_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psFunctionPrediction',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'gnomAD_g_mt_mitotip_score_pred',
      value: variant => predictionMetaDatas['gnomAD_g_mt_mitotip'].displayMap[variant.gnomAD_g_mt_mitotip_score_pred] || variant.gnomAD_g_mt_mitotip_score_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['gnomAD_g_mt_mitotip'].checkPassed || (() => true))(variant.gnomAD_g_mt_mitotip_score, variant.gnomAD_g_mt_mitotip_score_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    // // Splice Site
    // default
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___ada_score',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'ada_score',
      value: variant => variant.ada_score,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['ada'].checkPassed || (() => true))(variant.ada_score, variant.ada_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___ada_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'ada_pred',
      value: variant => predictionMetaDatas['ada'].displayMap[variant.ada_pred] || variant.ada_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['ada'].checkPassed || (() => true))(variant.ada_score, variant.ada_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___rf_score',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'rf_score',
      value: variant => variant.rf_score,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['rf'].checkPassed || (() => true))(variant.rf_score, variant.rf_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___rf_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'rf_pred',
      value: variant => predictionMetaDatas['rf'].displayMap[variant.rf_pred] || variant.rf_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['rf'].checkPassed || (() => true))(variant.rf_score, variant.rf_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DS_AG',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'CI_SpliceAI_DS_AG',
      value: variant => variant.CI_SpliceAI_DS_AG,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DS_AG'].checkPassed || (() => true))(variant.CI_SpliceAI_DS_AG) + ''] || 'empty'],
      long: false
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DS_AL',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'CI_SpliceAI_DS_AL',
      value: variant => variant.CI_SpliceAI_DS_AL,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DS_AL'].checkPassed || (() => true))(variant.CI_SpliceAI_DS_AL) + ''] || 'empty'],
      long: false
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DS_DG',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'CI_SpliceAI_DS_DG',
      value: variant => variant.CI_SpliceAI_DS_DG,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DS_DG'].checkPassed || (() => true))(variant.CI_SpliceAI_DS_DG) + ''] || 'empty'],
      long: false
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DS_DL',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'CI_SpliceAI_DS_DL',
      value: variant => variant.CI_SpliceAI_DS_DL,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DS_DL'].checkPassed || (() => true))(variant.CI_SpliceAI_DS_DL) + ''] || 'empty'],
      long: false
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DP_AG',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'CI_SpliceAI_DP_AG',
      value: variant => variant.CI_SpliceAI_DP_AG,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DP_AG'].checkPassed || (() => true))(variant.CI_SpliceAI_DP_AG) + ''] || 'empty'],
      long: false
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DP_AL',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'CI_SpliceAI_DP_AL',
      value: variant => variant.CI_SpliceAI_DP_AL,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DP_AL'].checkPassed || (() => true))(variant.CI_SpliceAI_DP_AL) + ''] || 'empty'],
      long: false
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DP_DG',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'CI_SpliceAI_DP_DG',
      value: variant => variant.CI_SpliceAI_DP_DG,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DP_DG'].checkPassed || (() => true))(variant.CI_SpliceAI_DP_DG) + ''] || 'empty'],
      long: false
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___CI_SpliceAI_DP_DL',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'CI_SpliceAI_DP_DL',
      value: variant => variant.CI_SpliceAI_DP_DL,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['CI_SpliceAI_DP_DL'].checkPassed || (() => true))(variant.CI_SpliceAI_DP_DL) + ''] || 'empty'],
      long: false
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SpliceAI',
      link: {
        title: 'CONSTANT.global.data.reportPreviewOptions.linkTitle.___SpliceAI',
        url: variant => 'https://spliceailookup.broadinstitute.org/#variant=' + [variant.CHROM, variant.POS, variant.REF, variant.ALT].join('-') + '&hg=38&distance=50&mask=0&precomputed=1'
      },
      long: true,
      old: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DS_AG',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SpliceAI_DS_AG',
      value: variant => variant.SpliceAI_DS_AG,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DS_AG'].checkPassed || (() => true))(variant.SpliceAI_DS_AG) + ''] || 'empty'],
      long: true,
      old: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DS_AL',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SpliceAI_DS_AL',
      value: variant => variant.SpliceAI_DS_AL,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DS_AL'].checkPassed || (() => true))(variant.SpliceAI_DS_AL) + ''] || 'empty'],
      long: true,
      old: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DS_DG',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SpliceAI_DS_DG',
      value: variant => variant.SpliceAI_DS_DG,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DS_DG'].checkPassed || (() => true))(variant.SpliceAI_DS_DG) + ''] || 'empty'],
      long: true,
      old: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DS_DL',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SpliceAI_DS_DL',
      value: variant => variant.SpliceAI_DS_DL,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DS_DL'].checkPassed || (() => true))(variant.SpliceAI_DS_DL) + ''] || 'empty'],
      long: true,
      old: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DP_AG',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SpliceAI_DP_AG',
      value: variant => variant.SpliceAI_DP_AG,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DP_AG'].checkPassed || (() => true))(variant.SpliceAI_DP_AG) + ''] || 'empty'],
      long: true,
      old: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DP_AL',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SpliceAI_DP_AL',
      value: variant => variant.SpliceAI_DP_AL,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DP_AL'].checkPassed || (() => true))(variant.SpliceAI_DP_AL) + ''] || 'empty'],
      long: true,
      old: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DP_DG',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SpliceAI_DP_DG',
      value: variant => variant.SpliceAI_DP_DG,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DP_DG'].checkPassed || (() => true))(variant.SpliceAI_DP_DG) + ''] || 'empty'],
      long: true,
      old: true
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SpliceAI_DP_DL',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psSpliceSite',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SpliceAI_DP_DL',
      value: variant => variant.SpliceAI_DP_DL,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SpliceAI_DP_DL'].checkPassed || (() => true))(variant.SpliceAI_DP_DL) + ''] || 'empty'],
      long: true,
      old: true
    },
    // // Conservation
    // default
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___GERPpp_NR',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psConservation',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'GERPpp_NR',
      value: variant => variant.GERPpp_NR,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['GERPpp_NR'].checkPassed || (() => true))(variant.GERPpp_NR) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___GERPpp_RS',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psConservation',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'GERPpp_RS',
      value: variant => variant.GERPpp_RS,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['GERPpp_RS'].checkPassed || (() => true))(variant.GERPpp_RS, variant.GERPpp_RS_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___GERPpp_RS_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psConservation',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'GERPpp_RS_pred',
      value: variant => predictionMetaDatas['GERPpp_RS'].displayMap[variant.GERPpp_RS_pred] || variant.GERPpp_RS_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['GERPpp_RS'].checkPassed || (() => true))(variant.GERPpp_RS, variant.GERPpp_RS_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SiPhy_29way_logOdds',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psConservation',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SiPhy_29way_logOdds',
      value: variant => variant.SiPhy_29way_logOdds,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SiPhy_29way_logOdds'].checkPassed || (() => true))(variant.SiPhy_29way_logOdds, variant.SiPhy_29way_logOdds_pred) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SiPhy_29way_logOdds_pred',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psConservation',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SiPhy_29way_logOdds_pred',
      value: variant => predictionMetaDatas['SiPhy_29way_logOdds'].displayMap[variant.SiPhy_29way_logOdds_pred] || variant.SiPhy_29way_logOdds_pred,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SiPhy_29way_logOdds'].checkPassed || (() => true))(variant.SiPhy_29way_logOdds, variant.SiPhy_29way_logOdds_pred) + ''] || 'empty']
      // class: value => (value || value === 0) ? ['normal'] : ['empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___SiPhy_29way_pi',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psConservation',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'SiPhy_29way_pi',
      value: variant => variant.SiPhy_29way_pi ? variant.SiPhy_29way_pi.split(':').map(v => (fixNumber(v, 0.01) + '').replace(/^0$/, '0.0')).join(':') : variant.SiPhy_29way_pi,
      hover: variant => variant.SiPhy_29way_pi,
      class: (value, variant) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['SiPhy_29way_pi'].checkPassed || (() => true))(variant.SiPhy_29way_pi) + ''] || 'empty']
    },
    // // gnomAD Constraint
    // default
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___oe_syn',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psgnomADConstraint',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'oe_syn',
      value: (variant, gene) => (gene || variant || {}).oe_syn,
      class: (value, variant, gene) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['oe_syn'].checkPassed || (() => true))((gene || variant || {}).oe_syn) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___oe_mis',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psgnomADConstraint',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'oe_mis',
      value: (variant, gene) => (gene || variant || {}).oe_mis,
      class: (value, variant, gene) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['oe_mis'].checkPassed || (() => true))((gene || variant || {}).oe_mis) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___oe_lof',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psgnomADConstraint',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'oe_lof',
      value: (variant, gene) => (gene || variant || {}).oe_lof,
      class: (value, variant, gene) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['oe_lof'].checkPassed || (() => true))((gene || variant || {}).oe_lof) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___syn_z',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psgnomADConstraint',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'syn_z',
      value: (variant, gene) => (gene || variant || {}).syn_z,
      class: (value, variant, gene) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['syn_z'].checkPassed || (() => true))((gene || variant || {}).syn_z) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___mis_z',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psgnomADConstraint',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'mis_z',
      value: (variant, gene) => (gene || variant || {}).mis_z,
      class: (value, variant, gene) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['mis_z'].checkPassed || (() => true))((gene || variant || {}).mis_z) + ''] || 'empty']
    },
    {
      title: 'CONSTANT.global.data.reportPreviewOptions.title.___pLI',
      group: '__DEFAULT',
      category: 'CONSTANT.global.data.reportPreviewOptions.categoryTitle.___psgnomADConstraint',
      resultGroup: '__DEFAULT',
      resultCategory: '__DEFAULT',
      key: 'pLI',
      value: (variant, gene) => (gene || variant || {}).pLI,
      class: (value, variant, gene) => [{
        'true': 'normal',
        'false': 'alert'
      }[(predictionMetaDatas['pLI'].checkPassed || (() => true))((gene || variant || {}).pLI) + ''] || 'empty']
    }
  ]
}

export const reportPreviewTypeMap = Object.entries(reportPreviewOptions).reduce((typeMap, [type, options]) => {
  let map = options.reduce((keyMap, option) => ({ ...keyMap, [option.key]: type }), {})
  return { ...typeMap, ...map }
}, {})

export const datasetStatusMap = {
  created: {
    title: 'CONSTANT.global.data.datasetStatusMap.title.___created',
    color: '#333333'
  },
  analyzing: {
    title: 'CONSTANT.global.data.datasetStatusMap.title.___analyzing',
    color: '#83C91E'
  },
  completed: {
    title: 'CONSTANT.global.data.datasetStatusMap.title.___completed',
    color: '#003679'
  },
  failed: {
    title: 'CONSTANT.global.data.datasetStatusMap.title.___failed',
    color: '#BE0F0F'
  },
  disabled: {
    title: 'CONSTANT.global.data.datasetStatusMap.title.___disabled',
    color: '#BE0F0F'
  }
}

export const datasetPermissionTypeMap = {
  private: {
    title: 'CONSTANT.global.data.datasetPermissionTypeMap.title.___private'
  },
  community: {
    title: 'CONSTANT.global.data.datasetPermissionTypeMap.title.___community'
  }
}

export const datasetPermissionMap = {
  private: {
    title: 'CONSTANT.global.data.datasetPermissionMap.title.___private',
    color: '#BE0F0F',
    type: 'private'
  },
  basic: {
    title: 'CONSTANT.global.data.datasetPermissionMap.title.___basic',
    color: '#333333',
    type: 'community'
  },
  explore: {
    title: 'CONSTANT.global.data.datasetPermissionMap.title.___explore',
    color: '#003679',
    type: 'community'
  },
  full: {
    title: 'CONSTANT.global.data.datasetPermissionMap.title.___full',
    color: '#83C91E',
    type: 'community'
  }
}

export const datasetInvitationPermissionMap = {
  explore: {
    title: 'CONSTANT.global.data.datasetInvitationPermissionMap.title.___explore'
  },
  full: {
    title: 'CONSTANT.global.data.datasetInvitationPermissionMap.title.___full'
  }
}

export const datasetPipelineMap = {
  WES: {
    title: 'CONSTANT.global.data.datasetPipelineMap.title.___WES'
  },
  WGS: {
    title: 'CONSTANT.global.data.datasetPipelineMap.title.___WGS'
  }
}

export const datasetShareAlert = dataset => {
  if (dataset.external_data_included) return 'CONSTANT.global.data.datasetShareAlert.___external_data_included'
  if (dataset.disabled) return 'CONSTANT.global.data.datasetShareAlert.___disabled'
  if (['analyzing'].includes(dataset.state)) return 'CONSTANT.global.data.datasetShareAlert.___analyzing'
  if (['created', 'failed'].includes(dataset.state)) return 'CONSTANT.global.data.datasetShareAlert.___failed'
  return null
}

export const familyRelationOptions = [
  {
    title: 'CONSTANT.global.data.familyRelationOptions.title.___Father',
    value: 'Father',
    group: 'Father',
    sex: 'Male',
    limit: 1
  },
  {
    title: 'CONSTANT.global.data.familyRelationOptions.title.___Mother',
    value: 'Mother',
    group: 'Mother',
    sex: 'Female',
    limit: 1
  },
  {
    title: 'CONSTANT.global.data.familyRelationOptions.title.___Brother',
    value: 'Brother',
    group: 'Proband',
    sex: 'Male',
    limit: null
  },
  {
    title: 'CONSTANT.global.data.familyRelationOptions.title.___Sister',
    value: 'Sister',
    group: 'Proband',
    sex: 'Female',
    limit: null
  },
  {
    title: 'CONSTANT.global.data.familyRelationOptions.title.___PaternalGrandfather',
    value: 'Paternal Grandfather',
    group: 'Paternal Grandfather',
    sex: 'Male',
    limit: 1
  },
  {
    title: 'CONSTANT.global.data.familyRelationOptions.title.___PaternalGrandmother',
    value: 'Paternal Grandmother',
    group: 'Paternal Grandmother',
    sex: 'Female',
    limit: 1
  },
  {
    title: 'CONSTANT.global.data.familyRelationOptions.title.___MaternalGrandfather',
    value: 'Maternal Grandfather',
    group: 'Maternal Grandfather',
    sex: 'Male',
    limit: 1
  },
  {
    title: 'CONSTANT.global.data.familyRelationOptions.title.___MaternalGrandmother',
    value: 'Maternal Grandmother',
    group: 'Maternal Grandmother',
    sex: 'Female',
    limit: 1
  },
  {
    title: 'CONSTANT.global.data.familyRelationOptions.title.___PaternalUncle',
    value: 'Paternal Uncle',
    group: 'Father',
    sex: 'Male',
    limit: null
  },
  {
    title: 'CONSTANT.global.data.familyRelationOptions.title.___PaternalAunt',
    value: 'Paternal Aunt',
    group: 'Father',
    sex: 'Female',
    limit: null
  },
  {
    title: 'CONSTANT.global.data.familyRelationOptions.title.___MaternalUncle',
    value: 'Maternal Uncle',
    group: 'Mother',
    sex: 'Male',
    limit: null
  },
  {
    title: 'CONSTANT.global.data.familyRelationOptions.title.___MaternalAunt',
    value: 'Maternal Aunt',
    group: 'Mother',
    sex: 'Female',
    limit: null
  }
]

export const svClinvarOptions = [
  {
    title: 'CONSTANT.global.data.svClinvarOptions.title.___Pathogenic',
    subtitle: 'CONSTANT.global.data.svClinvarOptions.subtitle.___Pathogenic',
    value: 'Pathogenic',
    countValue: 'dbvar_patho_count',
    color: '#FA3D3D',
    grid: 2,
    order: {
      'overview': 1,
      'table': 1
    }
  },
  {
    title: 'CONSTANT.global.data.svClinvarOptions.title.___Likely_Pathogenic',
    subtitle: 'CONSTANT.global.data.svClinvarOptions.subtitle.___Likely_Pathogenic',
    value: 'Likely_pathogenic',
    countValue: 'dbvar_likely_patho_count',
    color: '#FF9E03',
    grid: 3,
    order: {
      'overview': 2,
      'table': 3
    }
  },
  {
    title: 'CONSTANT.global.data.svClinvarOptions.title.___Benign',
    subtitle: 'CONSTANT.global.data.svClinvarOptions.subtitle.___Benign',
    value: 'Benign',
    countValue: 'dbvar_benign_count',
    color: '#003679',
    grid: 2,
    order: {
      'overview': 5,
      'table': 4
    }
  },
  {
    title: 'CONSTANT.global.data.svClinvarOptions.title.___Likely_Benign',
    subtitle: 'CONSTANT.global.data.svClinvarOptions.subtitle.___Likely_Benign',
    value: 'Likely_benign',
    countValue: 'dbvar_likely_benign_count',
    color: '#83C91E',
    grid: 2,
    order: {
      'overview': 4,
      'table': 2
    }
  },
  {
    title: 'CONSTANT.global.data.svClinvarOptions.title.___Variant_of_Uncertain_Significance',
    subtitle: 'CONSTANT.global.data.svClinvarOptions.subtitle.___Variant_of_Uncertain_Significance',
    value: 'Uncertain_significance',
    countValue: 'dbvar_uncertain_count',
    color: '#F8C600',
    bold: true,
    grid: 5,
    order: {
      'overview': 3,
      'table': 5
    }
  },
  {
    title: 'CONSTANT.global.data.svClinvarOptions.title.___Conflicting_interpretations_of_pathogenicity',
    subtitle: 'CONSTANT.global.data.svClinvarOptions.subtitle.___Conflicting_interpretations_of_pathogenicity',
    value: 'Conflicting_interpretations_of_pathogenicity',
    countValue: 'dbvar_conflict_count',
    grid: 7,
    hidden: true
  }
]

export const svDECIPHEROptions = [
  {
    title: 'CONSTANT.global.data.svDECIPHEROptions.title.___Pathogenic',
    subtitle: 'CONSTANT.global.data.svDECIPHEROptions.subtitle.___Pathogenic',
    value: 'Pathogenic',
    countValue: 'decipher_patho_count',
    color: '#FA3D3D',
    grid: 2,
    order: {
      'overview': 1,
      'table': 1
    }
  },
  {
    title: 'CONSTANT.global.data.svDECIPHEROptions.title.___Likely_Pathogenic',
    subtitle: 'CONSTANT.global.data.svDECIPHEROptions.subtitle.___Likely_Pathogenic',
    value: 'Likely_pathogenic',
    countValue: 'decipher_likely_patho_count',
    color: '#FF9E03',
    grid: 3,
    order: {
      'overview': 2,
      'table': 3
    }
  },
  {
    title: 'CONSTANT.global.data.svDECIPHEROptions.title.___Benign',
    subtitle: 'CONSTANT.global.data.svDECIPHEROptions.subtitle.___Benign',
    value: 'Benign',
    countValue: 'decipher_benign_count',
    color: '#003679',
    grid: 2,
    order: {
      'overview': 5,
      'table': 4
    }
  },
  {
    title: 'CONSTANT.global.data.svDECIPHEROptions.title.___Likely_Benign',
    subtitle: 'CONSTANT.global.data.svDECIPHEROptions.subtitle.___Likely_Benign',
    value: 'Likely_benign',
    countValue: 'decipher_likely_benign_count',
    color: '#83C91E',
    grid: 2,
    order: {
      'overview': 4,
      'table': 2
    }
  },
  {
    title: 'CONSTANT.global.data.svDECIPHEROptions.title.___Uncertain_Significance',
    subtitle: 'CONSTANT.global.data.svDECIPHEROptions.subtitle.___Uncertain_Significance',
    value: 'Uncertain_significance',
    countValue: 'decipher_uncertain_count',
    color: '#F8C600',
    bold: true,
    grid: 3,
    order: {
      'overview': 3,
      'table': 5
    }
  },
  {
    title: 'CONSTANT.global.data.svDECIPHEROptions.title.___Others',
    subtitle: 'CONSTANT.global.data.svDECIPHEROptions.subtitle.___Others',
    value: 'Others',
    countValue: 'decipher_conflict_count',
    grid: 2,
    hidden: true
  }
]

export const svDosageSensitivityOptions = [
  {
    title: 'CONSTANT.global.data.svDosageSensitivityOptions.title.___Sufficient_evidence_for_dosage_pathogenicity',
    value: 3,
    alert: true
  },
  {
    title: 'CONSTANT.global.data.svDosageSensitivityOptions.title.___Some_evidence_for_dosage_pathogenicity',
    value: 2,
    alert: true
  },
  {
    title: 'CONSTANT.global.data.svDosageSensitivityOptions.title.___Little_evidence_for_dosage_pathogenicity',
    value: 1,
    alert: true
  },
  {
    title: 'CONSTANT.global.data.svDosageSensitivityOptions.title.___No_evidence_for_dosage_pathogenicity',
    value: 0,
    alert: false
  },
  {
    title: 'CONSTANT.global.data.svDosageSensitivityOptions.title.___Evidence_suggests_the_gene_is_not_dosage_sensitive',
    value: 40,
    alert: false
  },
  {
    title: 'CONSTANT.global.data.svDosageSensitivityOptions.title.___Gene_associated_with_autosomal_recessive_phenotype',
    value: 30,
    alert: false
  }
]

export const svGenotypeOptions = [
  {
    title: 'CONSTANT.global.data.svGenotypeOptions.title.___Homozygous_reference',
    value: 'Homozygous reference'
  },
  {
    title: 'CONSTANT.global.data.svGenotypeOptions.title.___Heterozygous',
    value: 'Heterozygous'
  },
  {
    title: 'CONSTANT.global.data.svGenotypeOptions.title.___Homozygous_alternate',
    value: 'Homozygous alternate'
  }
]

export const svTypeOptions = [
  {
    title: 'CONSTANT.global.data.svTypeOptions.title.___DEL',
    value: 'Deletion',
    color: '#E37F72'
  },
  {
    title: 'CONSTANT.global.data.svTypeOptions.title.___INS',
    value: 'Insertion',
    color: '#77C474'
  },
  {
    title: 'CONSTANT.global.data.svTypeOptions.title.___DUP',
    value: 'Duplication',
    color: '#5DACE6'
  },
  {
    title: 'CONSTANT.global.data.svTypeOptions.title.___INV',
    value: 'Inversion',
    color: '#D5AF4A'
  },
  {
    title: '',
    value: 'Translocation',
    color: '#C359D1',
    filter: false
  },
  {
    title: 'CONSTANT.global.data.svTypeOptions.title.___CNV',
    value: 'Copy number variation'
  },
  {
    title: 'CONSTANT.global.data.svTypeOptions.title.___BND',
    value: 'Breakend'
  }
]

export const strClassificationMap = {
  'Pathogenic': {
    title: 'CONSTANT.global.data.strClassificationMap.title.___Pathogenic',
    key: 'Pathogenic',
    color: '#FA3D3D',
    bold: false
  },
  'Indeterminate': {
    title: 'CONSTANT.global.data.strClassificationMap.title.___Indeterminate',
    key: 'Indeterminate',
    color: '#F8C600',
    bold: true
  },
  'Intermediate': {
    title: 'CONSTANT.global.data.strClassificationMap.title.___Intermediate',
    key: 'Intermediate',
    color: '#F8C600',
    bold: false
  },
  'Normal': {
    title: 'CONSTANT.global.data.strClassificationMap.title.___Normal',
    key: 'Normal',
    color: '#349CCF',
    bold: false
  }
}

export const intractableDiseaseDifficutyMap = {
  0: {
    title: 'CONSTANT.global.data.intractableDiseaseDifficutyMap.title.___easy'
  },
  1: {
    title: 'CONSTANT.global.data.intractableDiseaseDifficutyMap.title.___hard'
  },
  2: {
    title: 'CONSTANT.global.data.intractableDiseaseDifficutyMap.title.___very_hard'
  }
}

export const intractableDiseaseMethodMap = {
  'A': {
    title: 'CONSTANT.global.data.intractableDiseaseMethodMap.title.___A',
    symbol: 'CONSTANT.global.data.intractableDiseaseMethodMap.symbol.___A',
    info: 'CONSTANT.global.data.intractableDiseaseMethodMap.info.___A'
  },
  'I': {
    title: 'CONSTANT.global.data.intractableDiseaseMethodMap.title.___I',
    symbol: 'CONSTANT.global.data.intractableDiseaseMethodMap.symbol.___I',
    info: 'CONSTANT.global.data.intractableDiseaseMethodMap.info.___I'
  },
  'U': {
    title: 'CONSTANT.global.data.intractableDiseaseMethodMap.title.___U',
    symbol: 'CONSTANT.global.data.intractableDiseaseMethodMap.symbol.___U',
    info: 'CONSTANT.global.data.intractableDiseaseMethodMap.info.___U'
  },
  'E': {
    title: 'CONSTANT.global.data.intractableDiseaseMethodMap.title.___E',
    symbol: 'CONSTANT.global.data.intractableDiseaseMethodMap.symbol.___E',
    info: 'CONSTANT.global.data.intractableDiseaseMethodMap.info.___E'
  },
  'O': {
    title: 'CONSTANT.global.data.intractableDiseaseMethodMap.title.___O',
    symbol: 'CONSTANT.global.data.intractableDiseaseMethodMap.symbol.___O',
    info: 'CONSTANT.global.data.intractableDiseaseMethodMap.info.___O'
  }
}

export const intractableDiseaseOptions = [
  // D006-4
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Duchenne_muscular_dystrophy',
    value: 'Duchenne muscular dystrophy',
    type: 'D006-4',
    difficuty: 0,
    method: 'A',
    nandoID: 'NANDO:1200488',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4523'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01963'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Becker_muscular_dystrophy',
    value: 'Becker muscular dystrophy',
    type: 'D006-4',
    difficuty: 0,
    method: 'A',
    nandoID: 'NANDO:1200489',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4523'
      ],
      other: [
        'https://www.genome.jp/entry/ds_ja:H01964'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_amyloidosis',
    value: 'Familial amyloidosis',
    type: 'D006-4',
    difficuty: 0,
    method: 'A',
    nandoID: 'NANDO:1200214',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/207'
      ],
      other: [
        'https://www.kegg.jp/dbget-bin/www_bget?H00845+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Spinal_and_bulbar_muscular_atrophy_SBMA',
    value: 'Spinal and bulbar muscular atrophy (SBMA)',
    type: 'D006-4',
    difficuty: 0,
    method: 'I',
    nandoID: 'NANDO:1200001',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/234'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00062'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Myotonic_dystrophy',
    value: 'Myotonic dystrophy',
    type: 'D006-4',
    difficuty: 0,
    method: 'U',
    nandoID: 'NANDO:1200495',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/529'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00568'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lysosomal_storage_diseases_including_mucopolysaccharidosis_type_I_mucopolysaccharidosis_type_II_Gaucher_disease_Fabry_disease_and_Pompe_disease',
    value: 'Lysosomal storage diseases (including mucopolysaccharidosis type I, mucopolysaccharidosis type II, Gaucher disease, Fabry disease, and Pompe disease)',
    type: 'D006-4',
    difficuty: 0,
    method: 'E',
    nandoID: 'NANDO:1200055',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4061'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01425'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fragile_X_syndrome',
    value: 'Fragile X syndrome',
    type: 'D006-4',
    difficuty: 0,
    method: 'E',
    nandoID: 'NANDO:1200692',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4613'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00465'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___TNF_receptor_associated_periodic_syndrome_TRAPS',
    value: 'TNF receptor-associated periodic syndrome (TRAPS)',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200472',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4034'
      ],
      other: [
        'https://www.kegg.jp/entry/H00912+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Nakajo_Nishimura_syndrome',
    value: 'Nakajo-Nishimura syndrome',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200867',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4583'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_Mediterranean_fever',
    value: 'Familial Mediterranean fever',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200863',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4448'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00288'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Bethlem_myopathy',
    value: 'Bethlem myopathy',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200220',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4006'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01340'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___X_linked_myopathy_with_excessive_autophagy',
    value: 'X-linked myopathy with excessive autophagy',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200223',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3824'
      ],
      other: [
        'https://www.kegg.jp/entry/H01781+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Non_dystrophic_myotonia_syndromes',
    value: 'Non-dystrophic myotonia syndromes',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200496',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4520'
      ],
      other: [
        'https://www.genome.jp/entry/ds_ja:H01780'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_periodic_limb_paralysis',
    value: 'Hereditary periodic (limb) paralysis',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200502',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4529'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00215'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Autosomal_recessive_leukodystrophy_with_alopecia_and_spondylometaphyseal_dysplasia',
    value: 'Autosomal recessive leukodystrophy with alopecia and spondylometaphyseal dysplasia',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200544',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4550'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01757'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Tuberous_sclerosis',
    value: 'Tuberous sclerosis',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200607',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4385'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00915'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pachydermoperiostosis',
    value: 'Pachydermoperiostosis',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200642',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4604'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00457'
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Neurofibromatosis_Type_I',
  //   value: 'Neurofibromatosis Type I',
  //   type: 'D006-4',
  //   difficuty: 0,
  //   method: 'O',
  //   nandoID: 'NANDO: 2201003',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/3992'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/ds_ja:H01437'
  //     ]
  //   }
  // },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Neurofibromatosis_Type_2',
  //   value: 'Neurofibromatosis Type 2',
  //   type: 'D006-4',
  //   difficuty: 0,
  //   method: 'O',
  //   nandoID: 'NANDO:1200227',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/275'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/ds_ja:H01438'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Alexander_disease',
    value: 'Alexander disease',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200554',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4346'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00065'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Chronic_non_specific_multiple_ulcers_of_the_small_intestine',
    value: 'Chronic non-specific multiple ulcers of the small intestine',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200902',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4709'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01853'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___TRPV4_related_disorder',
    value: 'TRPV4-related disorder',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1201098',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28604'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fukuyama_congenital_muscular_dystrophy',
    value: 'Fukuyama congenital muscular dystrophy',
    type: 'D006-4',
    difficuty: 1,
    method: 'A',
    nandoID: 'NANDO:1200494',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4523'
      ],
      other: [
        'https://www.kegg.jp/dbget-bin/www_bget?ds_ja:H01957'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Spinal_muscular_atrophy',
    value: 'Spinal muscular atrophy',
    type: 'D006-4',
    difficuty: 1,
    method: 'A',
    nandoID: 'NANDO:1200003',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/285'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00455'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Huntingtons_disease',
    value: 'Huntington\'s disease',
    type: 'D006-4',
    difficuty: 1,
    method: 'I',
    nandoID: 'NANDO:1200012',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/318'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00059'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Retinoblastoma',
    value: 'Retinoblastoma',
    type: 'D006-4',
    difficuty: 1,
    method: 'I',
    nandoID: 'NANDO:2200042',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/2226'
      ],
      other: [
        'https://www.kegg.jp/entry/H01513+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Medullary_thyroid_carcinoma',
    value: 'Medullary thyroid carcinoma',
    type: 'D006-4',
    difficuty: 1,
    method: 'I',
    nandoID: 'NANDO:2201054',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3308'
      ],
      other: [
        'https://www.kegg.jp/entry/H01592+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Multiple_endocrine_neoplasia_type_1_MEN1',
    value: 'Multiple endocrine neoplasia type 1 (MEN1)',
    type: 'D006-4',
    difficuty: 1,
    method: 'I',
    nandoID: 'NANDO:2200405',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3308'
      ],
      other: [
        'https://www.kegg.jp/entry/H01102+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Phenylketonuria_PKU',
    value: 'Phenylketonuria (PKU)',
    type: 'D006-4',
    difficuty: 1,
    method: 'U',
    nandoID: 'NANDO:1200784',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4748'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00167'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Homocystinuria',
    value: 'Homocystinuria',
    type: 'D006-4',
    difficuty: 1,
    method: 'U',
    nandoID: 'NANDO:1201038',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/22378'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00183'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Citrullinemia_type_I',
    value: 'Citrullinemia type I',
    type: 'D006-4',
    difficuty: 1,
    method: 'U',
    nandoID: 'NANDO:1200802',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5435'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00185'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Argininosuccinic_aciduria_Urea_cycle_disorder',
    value: 'Argininosuccinic aciduria (Urea cycle disorder)',
    type: 'D006-4',
    difficuty: 1,
    method: 'U',
    nandoID: 'NANDO:1200802',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4733'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00185'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Isovaleric_acidemia',
    value: 'Isovaleric acidemia',
    type: 'D006-4',
    difficuty: 1,
    method: 'U',
    nandoID: 'NANDO:1200798',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4817'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00173'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___HMG_CoA_lyase_deficiency',
    value: 'HMG-CoA lyase deficiency',
    type: 'D006-4',
    difficuty: 1,
    method: 'U',
    nandoID: 'NANDO:2200497',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/901'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Multiple_carboxylase_deficiency',
    value: 'Multiple carboxylase deficiency',
    type: 'D006-4',
    difficuty: 1,
    method: 'U',
    nandoID: 'NANDO:1200820',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4826'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00180'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Glutaric_acidemia_type_1',
    value: 'Glutaric acidemia type 1',
    type: 'D006-4',
    difficuty: 1,
    method: 'U',
    nandoID: 'NANDO:1200800',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4832'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00178'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___MCAD_deficiency_Medium_chain_acyl_CoA_dehydrogenase_deficiency',
    value: 'MCAD deficiency (Medium-chain acyl-CoA dehydrogenase deficiency)',
    type: 'D006-4',
    difficuty: 1,
    method: 'U',
    nandoID: 'NANDO:2200513',
    links: {
      center: [
        'https://www.shouman.jp/disease/details/08_03_045/'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00488'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___VLCAD_deficiency_Very_long_chain_acyl_CoA_dehydrogenase_deficiency',
    value: 'VLCAD deficiency (Very long-chain acyl-CoA dehydrogenase deficiency)',
    type: 'D006-4',
    difficuty: 1,
    method: 'U',
    nandoID: 'NANDO:1201109',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28612'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00392'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___CPT1_deficiency_Carnitine_palmitoyltransferase_I_deficiency',
    value: 'CPT1 deficiency (Carnitine palmitoyltransferase I deficiency)',
    type: 'D006-4',
    difficuty: 1,
    method: 'U',
    nandoID: 'NANDO:1200969',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5429'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H02596'
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Menkes_Disease_Congenital_disorder_of_copper_metabolism',
  //   value: 'Menkes Disease (Congenital disorder of copper metabolism)',
  //   type: 'D006-4',
  //   difficuty: 1,
  //   method: 'U',
  //   nandoID: 'NANDO:1200653',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/4730'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/ds_ja:H00209'
  //     ]
  //   }
  // },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Occipital_Horn_Syndrome_Congenital_disorder_of_copper_metabolism',
  //   value: 'Occipital Horn Syndrome (Congenital disorder of copper metabolism)',
  //   type: 'D006-4',
  //   difficuty: 1,
  //   method: 'U',
  //   nandoID: 'NANDO:1200654',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/4556'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/ds_ja:H01859'
  //     ]
  //   }
  // },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Wilson_Disease_Congenital_disorder_of_copper_metabolism',
  //   value: 'Wilson Disease (Congenital disorder of copper metabolism)',
  //   type: 'D006-4',
  //   difficuty: 1,
  //   method: 'U',
  //   nandoID: 'NANDO:1200655',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/4544'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/ds_ja:H00210'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cryopyrin_associated_periodic_syndromes_CAPS',
    value: 'Cryopyrin-associated periodic syndromes (CAPS)',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200465',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3995'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00282'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Neurodegeneration_with_brain_iron_accumulation_NBIA',
    value: 'Neurodegeneration with brain iron accumulation (NBIA)',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200542',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4808'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00833'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_cerebral_leukodystrophy_including_central_nervous_system_hypomyelination',
    value: 'Congenital cerebral leukodystrophy (including central nervous system hypomyelination)',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200575',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4887'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00679'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___PCDH19_related_disorder',
    value: 'PCDH19-related disorder',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200599',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4643'
      ],
      other: [
        'https://www.genome.jp/entry/ds_ja:H01775'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hypophosphatasia',
    value: 'Hypophosphatasia',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200656',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4565'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00213'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Apert_syndrome',
    value: 'Apert syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200667',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4679'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01755'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Rothmund_Thomson_syndrome',
    value: 'Rothmund-Thomson syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200671',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4472'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01734'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Prader_Willi_syndrome',
    value: 'Prader-Willi syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200678',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4769'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00478'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Angelman_syndrome',
    value: 'Angelman syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200686',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4771'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01732'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Smith_Magenis_syndrome',
    value: 'Smith-Magenis syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200687',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4854'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01791'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fragile_X_associated_disorders',
    value: 'Fragile X-associated disorders',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200690',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4616'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01731'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Wolfram_syndrome',
    value: 'Wolfram syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200757',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4790'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00854'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hyper_IgD_syndrome',
    value: 'Hyper IgD syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200866',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4751'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___PAPA_syndrome_Pyogenic_sterile_arthritis_pyoderma_gangrenosum_and_acne',
    value: 'PAPA syndrome (Pyogenic sterile arthritis, pyoderma gangrenosum, and acne)',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200868',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4796'
      ],
      other: [
        'https://www.kegg.jp/entry/H00287+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_anomaly_syndromes',
    value: 'Congenital anomaly syndromes',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200957',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5501'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___ACTH_resistance_syndrome',
    value: 'ACTH resistance syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200777',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4358'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00256'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Autosomal_recessive_punctate_epiphyseal_dysplasia_type_1_Peroxisomal_diseases_excluding_adrenoleukodystrophy',
    value: 'Autosomal recessive punctate epiphyseal dysplasia type 1(Peroxisomal diseases (excluding adrenoleukodystrophy))',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200758',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4622'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00205'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_partial_lipodystrophy',
    value: 'Familial partial lipodystrophy',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200861',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5333'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01475'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sotos_syndrome',
    value: 'Sotos syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200679',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4778'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00718'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Carnitine_deficiency_Carnitine_palmitoyltransferase_II_deficiency',
    value: 'Carnitine deficiency (Carnitine palmitoyltransferase II deficiency)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200969',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5429'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H02596'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Carnitine_deficiency_Carnitine_acylcarnitine_translocase_deficiency',
    value: 'Carnitine deficiency (Carnitine-acylcarnitine translocase deficiency)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200969',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5429'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H02596'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Carnitine_deficiency_OCTN2_deficiency_Primary_carnitine_deficiency',
    value: 'Carnitine deficiency (OCTN2 deficiency (Primary carnitine deficiency))',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200969',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5429'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H02596'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Citrin_deficiency',
    value: 'Citrin deficiency',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200978',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5435'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00185'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Non_ketotic_hyperglycinemia',
    value: 'Non-ketotic hyperglycinemia',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200984',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5441'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00191'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Beta_ketothiolase_deficiency',
    value: 'Beta-ketothiolase deficiency',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200987',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5444'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01076'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___3_Methylglutaconic_aciduria',
    value: '3-Methylglutaconic aciduria',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200989',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5450'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00754'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Glutaric_acidemia_type_2',
    value: 'Glutaric acidemia type 2',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200801',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4820'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00178'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_adrenal_hypoplasia',
    value: 'Congenital adrenal hypoplasia',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200403',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3853'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01772'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___ATR_X_syndrome_Alpha_thalassemia_X_linked_intellectual_disability_syndrome',
    value: 'ATR-X syndrome (Alpha-thalassemia X-linked intellectual disability syndrome)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200665',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4433'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01752'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hutchinson_Gilford_progeria_syndrome',
    value: 'Hutchinson-Gilford progeria syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1201007',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/6014'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00601'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Achondroplasia',
    value: 'Achondroplasia',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200877',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4571'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01749'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Progressive_Myoclonic_Epilepsy_Lafora_disease',
    value: 'Progressive Myoclonic Epilepsy (Lafora disease)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200955',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5426'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00810'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sepiapterin_reductase_SR_deficiency',
    value: 'Sepiapterin reductase (SR) deficiency',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200982',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5438'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H02597'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Aromatic_L_amino_acid_decarboxylase_deficiency',
    value: 'Aromatic L-amino acid decarboxylase deficiency',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200988',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5447'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01161'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Osler_disease_Hereditary_hemorrhagic_telangiectasia',
    value: 'Osler disease (Hereditary hemorrhagic telangiectasia)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200744',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4352'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00533'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___CFC_syndrome_Cardiofaciocutaneous_syndrome',
    value: 'CFC syndrome (Cardiofaciocutaneous syndrome)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200462',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4096'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01745'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Costello_syndrome',
    value: 'Costello syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200463',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4086'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01747'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___CHARGE_syndrome',
    value: 'CHARGE syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200464',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4139'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00556'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lysinuric_protein_intolerance',
    value: 'Lysinuric protein intolerance',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200809',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4682'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00899'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Adrenoleukodystrophy',
    value: 'Adrenoleukodystrophy',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200165',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/329'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00176'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Blau_syndrome',
    value: 'Blau syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200476',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3827'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00285'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Branchio_oto_renal_syndrome',
    value: 'Branchio-oto-renal syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200675',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4388'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00453'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Young_Simpson_syndrome',
    value: 'Young-Simpson syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200681',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4760'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01793'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_nephrogenic_diabetes_insipidus',
    value: 'Congenital nephrogenic diabetes insipidus',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200742',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5538'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00252'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Vitamin_D_dependent_rickets_osteomalacia',
    value: 'Vitamin D-dependent rickets/osteomalacia',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200781',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4562'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01143'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Nail_patella_syndrome_LMX1B_associated_nephropathy',
    value: 'Nail-patella syndrome / LMX1B-associated nephropathy',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200966',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5471'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___GLUT1_deficiency_syndrome',
    value: 'GLUT1 deficiency syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200799',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4454'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00836'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Resistance_to_thyroid_hormone',
    value: 'Resistance to thyroid hormone',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200395',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/258'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00249'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Weaver_syndrome',
    value: 'Weaver syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200659',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4685'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01751'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Coffin_Lowry_syndrome',
    value: 'Coffin-Lowry syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200660',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4667'
      ],
      other: [
        'https://www.kegg.jp/entry/H00574+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Mowat_Wilson_syndrome',
    value: 'Mowat-Wilson syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200663',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4595'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00908'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hepatic_glycogen_storage_diseases_types_I_III_VI_IXa_IXb_IXc_IV',
    value: 'Hepatic glycogen storage diseases (types I, III, VI, IXa, IXb, IXc, IV)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200838',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5330'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01760'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Myopathic_glycogen_storage_diseases_types_III_IV_IXd',
    value: 'Myopathic glycogen storage diseases (types III, IV, IXd)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200823',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4712'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01762'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_protein_C_deficiency',
    value: 'Congenital protein C deficiency',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1201080',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5420'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00223'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_protein_S_deficiency',
    value: 'Congenital protein S deficiency',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1201081',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5420'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00223'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_antithrombin_deficiency',
    value: 'Congenital antithrombin deficiency',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1201082',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5420'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01381'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Amyotrophic_lateral_sclerosis_ALS',
    value: 'Amyotrophic lateral sclerosis (ALS)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200002',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/214'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00058'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Distal_myopathy_with_rimmed_vacuoles',
    value: 'Distal myopathy with rimmed vacuoles',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200218',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4003'
      ],
      other: [
        'https://www.kegg.jp/entry/H02586+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Schwartz_Jampel_syndrome',
    value: 'Schwartz-Jampel syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200224',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3958'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01777'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hypertrophic_cardiomyopathy',
    value: 'Hypertrophic cardiomyopathy',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200286',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/320'
      ],
      other: [
        'https://www.kegg.jp/entry/H00292+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_hypercholesterolemia_holmozygous',
    value: 'Familial hypercholesterolemia (holmozygous)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:2200602',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/226'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00155'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_myopathy',
    value: 'Congenital myopathy',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200477',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4727'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01810'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___CADASIL_Cerebral_autosomal_dominant_arteriopathy_with_subcortical_infarcts_and_leukoencephalopathy',
    value: 'CADASIL (Cerebral autosomal dominant arteriopathy with subcortical infarcts and leukoencephalopathy)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200545',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4445'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00536'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_diffuse_leukoencephalopathy_with_axonal_spheroids',
    value: 'Hereditary diffuse leukoencephalopathy with axonal spheroids',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200546',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4499'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01807'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_insensitivity_to_pain_with_anhidrosis',
    value: 'Congenital insensitivity to pain with anhidrosis',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200553',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4361'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01836'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_benign_chronic_pemphigus_Hailey_Hailey_disease',
    value: 'Familial benign chronic pemphigus (Hailey-Hailey disease)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200631',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4490'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00844'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Nasu_Hakola_disease',
    value: 'Nasu-Hakola disease',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200658',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4257'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00438'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Carney_complex',
    value: 'Carney complex',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200756',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4754'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01820'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Peroxisome_biogenesis_disorder',
    value: 'Peroxisome biogenesis disorder',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200759',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4621'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00205'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Peroxisomal_beta_oxidation_enzyme_deficiency',
    value: 'Peroxisomal beta-oxidation enzyme deficiency',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200764',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4622'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00407'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Plasmalogen_synthesis_enzyme_deficiency',
    value: 'Plasmalogen synthesis enzyme deficiency',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200758',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4622'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Acatalasemia',
    value: 'Acatalasemia',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200774',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4622'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_hyperoxaluria_type_I',
    value: 'Primary hyperoxaluria type I',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200758',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4622'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00117'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Refsum_disease',
    value: 'Refsum disease',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200769',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4622'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00075'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_folate_malabsorption',
    value: 'Hereditary folate malabsorption',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200810',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4823'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01252'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Atypical_porphyria',
    value: 'Atypical porphyria',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200814',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5546'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01763'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_erythropoietic_porphyria',
    value: 'Congenital erythropoietic porphyria',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200817',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5546'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00201'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Acute_intermittent_porphyria',
    value: 'Acute intermittent porphyria',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200812',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5546'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00202'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Erythropoietic_protoporphyria',
    value: 'Erythropoietic protoporphyria',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200815',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5546'
      ],
      other: [
        'https://www.kegg.jp/entry/H00201+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___X_linked_protoporphyria',
    value: 'X-linked protoporphyria',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200818',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5546'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_coproporphyria',
    value: 'Hereditary coproporphyria',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200813',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5546'
      ],
      other: [
        'https://www.kegg.jp/entry/H00202+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Porphyria_cutanea_tarda',
    value: 'Porphyria cutanea tarda',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200816',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5546'
      ],
      other: [
        'https://www.kegg.jp/entry/H00202+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hepatoerythropoietic_porphyria',
    value: 'Hepatoerythropoietic porphyria',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200819',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5546'
      ],
      other: [
        'https://www.kegg.jp/entry/H00202+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_hyperchylomicronemia',
    value: 'Primary hyperchylomicronemia',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200855',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4884'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01784'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Abetalipoproteinemia',
    value: 'Abetalipoproteinemia',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200857',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4574'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00160'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Thanatophoric_dysplasia',
    value: 'Thanatophoric dysplasia',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200874',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4715'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01750'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_pancreatitis',
    value: 'Hereditary pancreatitis',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200921',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4781'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00933'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cystic_fibrosis',
    value: 'Cystic fibrosis',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200922',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4532'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00218'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Usher_syndrome_type_1_type_2_type_3',
    value: 'Usher syndrome (type 1, type 2, type 3)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200941',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4625'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00779'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Canavan_disease',
    value: 'Canavan disease',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200948',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5414'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00074'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_glycosylphosphatidylinositol_deficiency',
    value: 'Congenital glycosylphosphatidylinositol deficiency',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200983',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5411'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01489'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Osteopetrosis',
    value: 'Osteopetrosis',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200998',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5393'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00436'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cerebral_creatine_deficiency_syndrome',
    value: 'Cerebral creatine deficiency syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1201032',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/22426'
      ],
      other: [
        'https://www.genome.jp/entry/ds_ja:H00849'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Nephronophthisis',
    value: 'Nephronophthisis',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1201036',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/22438'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00537'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_hypobetalipoproteinemia_type_1_homozygous_form',
    value: 'Familial hypobetalipoproteinemia type 1 (homozygous form)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1201037',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/22449'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01270'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Progressive_familial_intrahepatic_cholestasis',
    value: 'Progressive familial intrahepatic cholestasis',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1201042',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/22459'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00624'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Nutritional_epidermolysis_bullosa',
    value: 'Nutritional epidermolysis bullosa',
    type: 'D006-4',
    difficuty: 2,
    method: 'A',
    nandoID: 'NANDO:1200234',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5339'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00587'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_long_QT_syndrome',
    value: 'Congenital long QT syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'A',
    nandoID: 'NANDO:2200228',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/2263'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00720'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Maple_syrup_urine_disease',
    value: 'Maple syrup urine disease',
    type: 'D006-4',
    difficuty: 2,
    method: 'U',
    nandoID: 'NANDO:1200791',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4814'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00172'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Methylmalonic_acidemia',
    value: 'Methylmalonic acidemia',
    type: 'D006-4',
    difficuty: 2,
    method: 'U',
    nandoID: 'NANDO:1200793',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4860'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00174'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Propionic_acidemia',
    value: 'Propionic acidemia',
    type: 'D006-4',
    difficuty: 2,
    method: 'U',
    nandoID: 'NANDO:1200792',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5324'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00175'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___3_Methylcrotonylglycinuria',
    value: '3-Methylcrotonylglycinuria',
    type: 'D006-4',
    difficuty: 2,
    method: 'U',
    nandoID: 'NANDO:2200495',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4826'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00181'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___MTP_LCHAD_deficiency_Triple_Enzyme_Deficiency',
    value: 'MTP (LCHAD) deficiency (Triple Enzyme Deficiency)',
    type: 'D006-4',
    difficuty: 2,
    method: 'U',
    nandoID: 'NANDO:1200974',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5432'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01352'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Xeroderma_pigmentosum',
    value: 'Xeroderma pigmentosum',
    type: 'D006-4',
    difficuty: 2,
    method: 'U',
    nandoID: 'NANDO:1200608',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/217'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01428'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Loeys_Dietz_syndrome',
    value: 'Loeys-Dietz syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'U',
    nandoID: 'NANDO:1200644',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/664'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00800'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Familial_thoracic_aortic_aneurysm_and_dissection',
    value: 'Familial thoracic aortic aneurysm and dissection',
    type: 'D006-4',
    difficuty: 2,
    method: 'U',
    nandoID: null,
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3306'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Neuroacanthocytosis',
    value: 'Neuroacanthocytosis',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200013',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4052'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00832'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_myasthenic_syndrome',
    value: 'Congenital myasthenic syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200021',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3997'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00770'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_immunodeficiency_syndrome',
    value: 'Primary immunodeficiency syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200320',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/254'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01725'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Perry_syndrome',
    value: 'Perry syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200547',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4703'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00879'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Crouzon_syndrome',
    value: 'Crouzon syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200666',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4673'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01754'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pfeiffer_syndrome',
    value: 'Pfeiffer syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200668',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4676'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01756'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Antley_Bixler_syndrome',
    value: 'Antley-Bixler syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200669',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4670'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01753'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Tangier_disease',
    value: 'Tangier disease',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200854',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4586'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00159'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_dyserythropoietic_anemia',
    value: 'Congenital dyserythropoietic anemia',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200885',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4364'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00917'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Early_onset_bilateral_sensorineural_hearing_loss',
    value: 'Early-onset bilateral sensorineural hearing loss',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200945',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4628'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01705'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Urea_cycle_disorder',
    value: 'Urea cycle disorder',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200802',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4733'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01398'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Marfan_syndrome_Loeys_Dietz_Syndrome',
    value: 'Marfan syndrome/Loeys-Dietz Syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200644',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4793'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00653'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Vascular_Ehlers_Danlos_syndrome',
    value: 'Vascular Ehlers-Danlos syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200645',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4802'
      ],
      other: [
        'https://www.kegg.jp/entry/H02242+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_autoinflammatory_disease',
    value: 'Hereditary autoinflammatory disease',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200993',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5408'
      ],
      other: [
        'https://www.kegg.jp/entry/H02599+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hereditary_dystonia',
    value: 'Hereditary dystonia',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200511',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4899'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00831'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Dravet_syndrome',
    value: 'Dravet syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200587',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4745'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01818'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Coffin_Siris_syndrome',
    value: 'Coffin-Siris syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200670',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4763'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H01403'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Kabuki_syndrome',
    value: 'Kabuki syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200672',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4664'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00570'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pulmonary_alveolar_proteinosis_autoimmune_or_congenital',
    value: 'Pulmonary alveolar proteinosis (autoimmune or congenital)',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200746',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4775'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00217'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Noonan_syndrome',
    value: 'Noonan syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200680',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4866'
      ],
      other: [
        'https://www.genome.jp/entry/ds_ja:H00523'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Osteogenesis_imperfecta',
    value: 'Osteogenesis imperfecta',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200873',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4568'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00506'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Spinocerebellar_degeneration_excluding_multiple_system_atrophy',
    value: 'Spinocerebellar degeneration (excluding multiple system atrophy)',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200037',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4880'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H01616'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Classical_Ehlers_Danlos_syndrome',
    value: 'Classical Ehlers-Danlos syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200646',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4802'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00802'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Atypical_hemolytic_uremic_syndrome_aHUS',
    value: 'Atypical hemolytic uremic syndrome (aHUS)',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200473',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3847'
      ],
      other: [
        'https://www.kegg.jp/entry/H01434+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Alport_syndrome',
    value: 'Alport syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200712',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4349'
      ],
      other: [
        'https://www.kegg.jp/entry/H00581+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fanconi_anemia',
    value: 'Fanconi anemia',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200891',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4442'
      ],
      other: [
        'https://www.kegg.jp/entry/H00238+-ja'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Alagille_syndrome',
    value: 'Alagille syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200918',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4845'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00551'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Rubinstein_Taybi_syndrome',
    value: 'Rubinstein-Taybi syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200461',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4068'
      ],
      other: [
        'https://www.genome.jp/dbget-bin/www_bget?ds_ja:H00504'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_ciliary_dyskinesia_including_Kartagener_syndrome',
    value: 'Primary ciliary dyskinesia (including Kartagener syndrome)',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1201096',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28601'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Proteinuria_group',
    value: 'Proteinuria group',
    type: 'D006-4',
    difficuty: -1,
    method: null,
    nandoID: 'NANDO: 3000005',
    links: {
      center: [
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cardiomyopathy_group',
    value: 'Cardiomyopathy group',
    type: 'D006-4',
    difficuty: -1,
    method: null,
    nandoID: 'NANDO: 3000004 ',
    links: {
      center: [
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Growth_disorder_intellectual_disability_and_characteristic_facial_features_group',
    value: 'Growth disorder, intellectual disability, and characteristic facial features group',
    type: 'D006-4',
    difficuty: -1,
    method: null,
    nandoID: 'NANDO: 3000002',
    links: {
      center: [
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Intellectual_disability_and_epilepsy_group',
    value: 'Intellectual disability and epilepsy group',
    type: 'D006-4',
    difficuty: -1,
    method: null,
    nandoID: 'NANDO: 3000003',
    links: {
      center: [
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fever_inflammation_rash_and_osteoarticular_syndrome_group',
    value: 'Fever, inflammation, rash, and osteoarticular syndrome group',
    type: 'D006-4',
    difficuty: -1,
    method: null,
    nandoID: 'NANDO: 3000006',
    links: {
      center: [
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Muscle_weakness_group',
    value: 'Muscle weakness group',
    type: 'D006-4',
    difficuty: -1,
    method: null,
    nandoID: 'NANDO: 3000001',
    links: {
      center: [
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Rett_syndrome',
    value: 'Rett syndrome',
    type: 'D006-4',
    difficuty: 0,
    method: 'E',
    nandoID: 'NANDO: 1200603',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4367'
      ],
      other: [
        'https://www.kegg.jp/entry/ds_ja:H00862'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lowe_syndrome_oculocerebrorenal_syndrome',
    value: 'Lowe syndrome (oculocerebrorenal syndrome)',
    type: 'D006-4',
    difficuty: 0,
    method: 'E',
    nandoID: 'NANDO: 2200188',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28624'
      ],
      other: [
        'https://www.kegg.jp/entry/H00692'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Miyoshi_myopathy',
    value: 'Miyoshi myopathy',
    type: 'D006-4',
    difficuty: 0,
    method: 'E',
    nandoID: 'NANDO: 1200217',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4003'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H01965'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lecithin_cholesterol_acyltransferase_LCAT_deficiency',
    value: 'Lecithin-cholesterol acyltransferase (LCAT) deficiency',
    type: 'D006-4',
    difficuty: 0,
    method: 'E',
    nandoID: 'NANDO:1200852',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4546'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00158'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sitosterolemia',
    value: 'Sitosterolemia',
    type: 'D006-4',
    difficuty: 0,
    method: 'E',
    nandoID: 'NANDO:1200853',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4857'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00152'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pseudohypoparathyroidism',
    value: 'Pseudohypoparathyroidism',
    type: 'D006-4',
    difficuty: 0,
    method: 'E',
    nandoID: 'NANDO:1200776',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/233'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00244'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Marinesco_Sjögren_syndrome',
    value: 'Marinesco-Sjögren syndrome',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200485',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4787'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H01284'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Galactose_1_phosphate_uridyltransferase_deficiency',
    value: 'Galactose-1-phosphate uridyltransferase deficiency',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200851',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4828'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H02008'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fibrodysplasia_ossificans_progressiva_FOP',
    value: 'Fibrodysplasia ossificans progressiva (FOP)',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200871',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/54'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00430'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Aniridia',
    value: 'Aniridia',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1201001',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5452'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00635'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___PURA_related_neurodevelopmental_disorders',
    value: 'PURA-related neurodevelopmental disorders',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO: 2201405',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28609'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Leber_hereditary_optic_neuropathy_LHON',
    value: 'Leber hereditary optic neuropathy (LHON)',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200940',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4661'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00068'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Alveolar_hypoventilation_syndrome',
    value: 'Alveolar hypoventilation syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200751',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/172'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cerebrotendinous_xanthomatosis_CTX',
    value: 'Cerebrotendinous xanthomatosis (CTX)',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200856',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4619'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00151'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Joubert_syndrome_and_related_disorders_JSRD',
    value: 'Joubert syndrome and related disorders (JSRD)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200661',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4552'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00530'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Werner_syndrome',
    value: 'Werner syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200676',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5321'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H01733'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cockayne_syndrome',
    value: 'Cockayne syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200677',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4436'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00076'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pseudoxanthoma_elasticum_PXE',
    value: 'Pseudoxanthoma elasticum (PXE)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200643',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4580'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00560'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diamond_Blackfan_anemia',
    value: 'Diamond-Blackfan anemia',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200890',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4421'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00237'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___LMNB1_related_leukoencephalopathy_ADLD',
    value: 'LMNB1-related leukoencephalopathy (ADLD)',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1201107',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28607'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_ichthyosis',
    value: 'Congenital ichthyosis',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200609',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/288'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H01771'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Oculocutaneous_albinism',
    value: 'Oculocutaneous albinism',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200637',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4493'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00168'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___STING_stimulator_of_interferon_genes_associated_vasculopathy_with_onset_in_infancy',
    value: 'STING (stimulator of interferon genes)-associated vasculopathy with onset in infancy',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO: 2201487',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28615'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Progressive_leukoencephalopathy',
    value: 'Progressive leukoencephalopathy',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200949',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5416'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H02598'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Charcot_Marie_Tooth_disease_CMT',
    value: 'Charcot-Marie-Tooth disease (CMT)',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200016',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3773'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00264'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_adrenal_hyperplasia_congenital_adrenal_enzyme_deficiency',
    value: 'Congenital adrenal hyperplasia (congenital adrenal enzyme deficiency)',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200396',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/185'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00258'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hemorrhagic_disorders_due_to_abnormal_fibrinolysis',
    value: 'Hemorrhagic disorders due to abnormal fibrinolysis',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1201112',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28622'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Mitochondrial_diseases',
    value: 'Mitochondrial diseases',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200173',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/335'
      ],
      other: [
        'https://www.kegg.jp/entry/H01427'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Epstein_syndrome',
    value: 'Epstein syndrome',
    type: 'D006-4',
    difficuty: 2,
    method: 'E',
    nandoID: 'NANDO:1200893',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4651'
      ],
      other: [
        'https://www.kegg.jp/entry/H01427'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___neurofibromatosis',
    value: 'Neurofibromatosis',
    type: 'D006-4',
    difficuty: 0,
    method: 'O',
    nandoID: 'NANDO:1200225',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5361'
      ],
      other: [
        'https://www.kegg.jp/entry/H01437'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___congenital_hearing_loss',
    value: 'Congenital hearing loss',
    type: 'D006-4',
    difficuty: 0,
    method: 'U',
    nandoID: 'NANDO:1200941',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4624'
      ],
      other: [
        'https://www.kegg.jp/entry/H00779'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___prion_disease',
    value: 'Prion disease',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200186',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5370'
      ],
      other: [
        'https://www.kegg.jp/entry/H00061'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___familial_idiopathic_basal_ganglia_calcification',
    value: 'Familial idiopathic basal ganglia calcification',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200208',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3838'
      ],
      other: [
        'https://www.kegg.jp/entry/H01574'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___williams_syndrome',
    value: 'Williams syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200664',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4766'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H01439'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___1p36_deletion_syndrome',
    value: '1p36 deletion syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200682',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4496'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H01792'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___4p_deletion_syndrome',
    value: '4p deletion syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200683',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4805'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H01773'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___5p_deletion_syndrome',
    value: '5p deletion syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200684',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4863'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00764'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___paternal_uniparental_disomy_of_chromosome_14',
    value: 'Paternal uniparental disomy of chromosome 14',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200685',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4688'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H01801'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___22q11_2_deletion_syndrome',
    value: '22q11.2 deletion syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200688',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5318'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H01525'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___unverricht_lundborg_disease',
    value: 'Unverricht-Lundborg disease',
    type: 'D006-4',
    difficuty: 1,
    method: 'O',
    nandoID: 'NANDO:1200954',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5426'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H01995'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___congenital_disorder_of_copper_metabolism',
    value: 'Congenital disorder of copper metabolism',
    type: 'D006-4',
    difficuty: 1,
    method: 'U',
    nandoID: null,
    links: {
      center: [
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___hereditary_sideroblastic_anemia',
    value: 'Hereditary sideroblastic anemia',
    type: 'D006-4',
    difficuty: 2,
    method: 'O',
    nandoID: 'NANDO:1200892',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4406'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H00982'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___ring_chromosome_20_syndrome',
    value: 'Ring chromosome 20 syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200597',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4577'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H01831'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___emanuel_syndrome',
    value: 'Emanuel syndrome',
    type: 'D006-4',
    difficuty: 1,
    method: 'E',
    nandoID: 'NANDO:1200689',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4610'
      ],
      other: [
        'https://identifiers.org/kegg.disease:H01790'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___dermatofibrosarcoma_protuberans',
    value: 'Dermatofibrosarcoma protuberans',
    type: 'D006-4',
    difficuty: 1,
    method: 'U',
    nandoID: null,
    links: {
      center: [
      ],
      other: [
      ]
    }
  },
  // default
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_lateral_sclerosis',
    value: 'Primary lateral sclerosis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200008',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/92'
      ],
      other: [
        'https://www.kegg.jp/entry/H00970'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Progressive_supranuclear_palsy',
    value: 'Progressive supranuclear palsy',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200009',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4114'
      ],
      other: [
        'https://www.kegg.jp/entry/H00077'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Parkinsons_disease',
    value: 'Parkinson\'s disease',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200010',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/169'
      ],
      other: [
        'https://www.kegg.jp/entry/H00057'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Corticobasal_degeneration',
    value: 'Corticobasal degeneration',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200011',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/142'
      ],
      other: [
        'https://www.kegg.jp/entry/H01600'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Charcot_Marie_Tooth_disease',
    value: 'Charcot-Marie-Tooth disease',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200016',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3773'
      ],
      other: [
        'https://www.kegg.jp/entry/H00264'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Myasthenia_gravis',
    value: 'Myasthenia gravis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200020',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/120'
      ],
      other: [
        'https://www.kegg.jp/entry/H01594'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Multiple_sclerosis_Neuromyelitis_optica_spectrum_disorders',
    value: 'Multiple sclerosis/Neuromyelitis optica spectrum disorders',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200022',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3806'
      ],
      other: [
        'https://www.kegg.jp/entry/H01490'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Chronic_inflammatory_demyelinating_polyneuropathy_Multifocal_motor_neuropathy',
    value: 'Chronic inflammatory demyelinating polyneuropathy/Multifocal motor neuropathy',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200029',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4089'
      ],
      other: [
        'https://www.kegg.jp/entry/H01527'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sporadic_inclusion_body_myositis',
    value: 'Sporadic inclusion body myositis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200032',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3801'
      ],
      other: [
        'https://www.kegg.jp/entry/H01505'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Multiple_system_atrophy',
    value: 'Multiple system atrophy',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200034',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5365'
      ],
      other: [
        'https://www.kegg.jp/entry/H01614'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Moyamoya_disease',
    value: 'Moyamoya disease',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200183',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/47'
      ],
      other: [
        'https://www.kegg.jp/entry/H01396'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pemphigus',
    value: 'Pemphigus',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200228',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/153'
      ],
      other: [
        'https://www.kegg.jp/entry/H01648'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pustular_psoriasis',
    value: 'Pustular psoriasis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200240',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/168'
      ],
      other: [
        'https://www.kegg.jp/entry/H01663'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Stevens_Johnson_syndrome',
    value: 'Stevens-Johnson syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200245',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4073'
      ],
      other: [
        'https://www.kegg.jp/entry/H01694'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Toxic_epidermal_necrolysis',
    value: 'Toxic epidermal necrolysis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200246',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4036'
      ],
      other: [
        'https://www.kegg.jp/entry/H01694'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Takayasu_arteritis',
    value: 'Takayasu arteritis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200251',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/141'
      ],
      other: [
        'https://www.kegg.jp/entry/H01465'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Giant_cell_arteritis',
    value: 'Giant cell arteritis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200258',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3928'
      ],
      other: [
        'https://www.kegg.jp/entry/H01698'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Polyarteritis_nodosa',
    value: 'Polyarteritis nodosa',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200261',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/85'
      ],
      other: [
        'https://www.kegg.jp/entry/H01382'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Granulomatosis_with_polyangiitis',
    value: 'Granulomatosis with polyangiitis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200263',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4011'
      ],
      other: [
        'https://www.kegg.jp/entry/H01655'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Systemic_lupus_erythematosus',
    value: 'Systemic lupus erythematosus',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200272',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/53'
      ],
      other: [
        'https://www.kegg.jp/entry/H00080'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Systemic_sclerosis',
    value: 'Systemic sclerosis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200277',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4026'
      ],
      other: [
        'https://www.kegg.jp/entry/H01492'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Behcets_disease',
    value: 'Behcet\'s disease',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200284',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/187'
      ],
      other: [
        'https://www.kegg.jp/entry/H01476'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Idiopathic_dilated_cardiomyopathy',
    value: 'Idiopathic dilated cardiomyopathy',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200285',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3985'
      ],
      other: [
        'https://www.kegg.jp/entry/H00294'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Restrictive_cardiomyopathy',
    value: 'Restrictive cardiomyopathy',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200292',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/100'
      ],
      other: [
        'https://www.kegg.jp/entry/H01219'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Aplastic_anemia',
    value: 'Aplastic anemia',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200295',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/106'
      ],
      other: [
        'https://www.kegg.jp/entry/H01132'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Paroxysmal_nocturnal_hemoglobinuria',
    value: 'Paroxysmal nocturnal hemoglobinuria',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200311',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3783'
      ],
      other: [
        'https://www.kegg.jp/entry/H01053'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Immune_thrombocytopenia',
    value: 'Immune thrombocytopenia',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200315',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/157'
      ],
      other: [
        'https://www.kegg.jp/entry/H01240'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Thrombotic_thrombocytopenic_purpura',
    value: 'Thrombotic thrombocytopenic purpura',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200316',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/87'
      ],
      other: [
        'https://www.kegg.jp/entry/H00225'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___IgA_nephropathy',
    value: 'IgA nephropathy',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200366',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/41'
      ],
      other: [
        'https://www.kegg.jp/entry/H01581'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Polycystic_kidney_disease',
    value: 'Polycystic kidney disease',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200367',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/146'
      ],
      other: [
        'https://www.kegg.jp/entry/H00542'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Ossification_of_posterior_longitudinal_ligament',
    value: 'Ossification of posterior longitudinal ligament',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200371',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/98'
      ],
      other: [
        'https://www.kegg.jp/entry/H00431'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Idiopathic_osteonecrosis_of_femoral_head',
    value: 'Idiopathic osteonecrosis of femoral head',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200373',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/160'
      ],
      other: [
        'https://www.kegg.jp/entry/H01529'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diencephalo_hypophysial_insufficiency_inappropriate_ADH_syndrome',
    value: 'Diencephalo-hypophysial insufficiency-inappropriate ADH syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200374',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3988'
      ],
      other: [
        'https://www.kegg.jp/entry/H01683'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diencephalo_hypophysial_insufficiency_inappropriate_thyroid_stimulating_hormone_syndrome',
    value: 'Diencephalo-hypophysial insufficiency-inappropriate thyroid stimulating hormone syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200377',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/64'
      ],
      other: [
        'https://www.kegg.jp/entry/H01701'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diencephalo_hypophysial_insufficiency_inappropriate_prolactin_syndrome',
    value: 'Diencephalo-hypophysial insufficiency-inappropriate prolactin syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200378',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4045'
      ],
      other: [
        'https://www.kegg.jp/entry/H01388'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cushing_disease',
    value: 'Cushing disease',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200379',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/78'
      ],
      other: [
        'https://www.kegg.jp/entry/H01431'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diencephalo_hypophysial_dysfunction_syndrome_of_abnormal_secretion_of_gonadotropin',
    value: 'Diencephalo-hypophysial dysfunction-syndrome of abnormal secretion of gonadotropin',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200380',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4070'
      ],
      other: [
        'https://www.kegg.jp/entry/H01860'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diencephalo_hypophysial_dysfunction_syndrome_of_abnormal_secretion_of_growth_hormone',
    value: 'Diencephalo-hypophysial dysfunction-syndrome of abnormal secretion of growth hormone',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200386',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3922'
      ],
      other: [
        'https://www.kegg.jp/entry/H01864'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hypopituitarism_syndrome',
    value: 'Hypopituitarism syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200387',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4017'
      ],
      other: [
        'https://www.kegg.jp/entry/H01700'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_adrenal_enzyme_deficiency',
    value: 'Congenital adrenal enzyme deficiency',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200396',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/185'
      ],
      other: [
        'https://www.kegg.jp/entry/H00258'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Addisons_disease',
    value: 'Addison\'s disease',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200411',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/44'
      ],
      other: [
        'https://www.kegg.jp/entry/H01598'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sarcoidosis',
    value: 'Sarcoidosis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200415',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/110'
      ],
      other: [
        'https://www.kegg.jp/entry/H01309'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pulmonary_arterial_hypertension',
    value: 'Pulmonary arterial hypertension',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200425',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/171'
      ],
      other: [
        'https://www.kegg.jp/entry/H01621'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pulmonary_veno_occlusive_disease_pulmonary_capillary_hemangiomatosis',
    value: 'Pulmonary veno-occlusive disease / pulmonary capillary hemangiomatosis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200426',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3868'
      ],
      other: [
        'https://www.kegg.jp/entry/H01866'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Chronic_thromboembolic_pulmonary_hypertension',
    value: 'Chronic thromboembolic pulmonary hypertension',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200429',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/192'
      ],
      other: [
        'https://www.kegg.jp/entry/H01622'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lymphangioleiomyomatosis',
    value: 'Lymphangioleiomyomatosis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200430',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/173'
      ],
      other: [
        'https://www.kegg.jp/entry/H00896'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Retinitis_pigmentosa',
    value: 'Retinitis pigmentosa',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200431',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/196'
      ],
      other: [
        'https://www.kegg.jp/entry/H00527'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Budd_Chiari_syndrome',
    value: 'Budd-Chiari syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200437',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/174'
      ],
      other: [
        'https://www.kegg.jp/entry/H01433'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_biliary_cholangitis',
    value: 'Primary biliary cholangitis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200439',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/93'
      ],
      other: [
        'https://www.kegg.jp/entry/H01467'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_sclerosing_cholangitis',
    value: 'Primary sclerosing cholangitis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200440',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3967'
      ],
      other: [
        'https://www.kegg.jp/entry/H01684'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Crohns_disease',
    value: 'Crohn\'s disease',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200444',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/81'
      ],
      other: [
        'https://www.kegg.jp/entry/H00286'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Ulcerative_colitis',
    value: 'Ulcerative colitis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200449',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/62'
      ],
      other: [
        'https://www.kegg.jp/entry/H01466'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Chronic_idiopathic_intestinal_pseudo_obstruction',
    value: 'Chronic idiopathic intestinal pseudo-obstruction',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200458',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3960'
      ],
      other: [
        'https://www.kegg.jp/entry/H01276'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Megacystis_microcolon_intestinal_hypoperistalsis_syndrome',
    value: 'Megacystis-microcolon-intestinal hypoperistalsis syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200459',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4064'
      ],
      other: [
        'https://www.kegg.jp/entry/H01869'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Juvenile_idiopathic_arthritis',
    value: 'Juvenile idiopathic arthritis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200469',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/3946'
      ],
      other: [
        'https://www.kegg.jp/entry/H01672'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Marinesco_Sjogren_syndrome',
    value: 'Marinesco-Sjogren syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200485',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4786'
      ],
      other: [
        'https://www.kegg.jp/entry/H01284'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Myelomeningocele',
    value: 'Myelomeningocele',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200509',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4633'
      ],
      other: [
        'https://www.kegg.jp/entry/H00262'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Frontotemporal_lobar_degeneration',
    value: 'Frontotemporal lobar degeneration',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200548',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4840'
      ],
      other: [
        'https://www.kegg.jp/entry/H00078'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Acute_encephalopathy_with_biphasic_seizures_and_late_reduced_diffusion',
    value: 'Acute encephalopathy with biphasic seizures and late reduced diffusion',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200552',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4513'
      ],
      other: [
        'https://www.kegg.jp/entry/H01841'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Moebius_syndrome',
    value: 'Moebius syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200559',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5326'
      ],
      other: [
        'https://www.kegg.jp/entry/H01840'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Septo_optic_dysplasia_De_Morsier_syndrome',
    value: 'Septo-optic dysplasia / De Morsier syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200560',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4402'
      ],
      other: [
        'https://www.kegg.jp/entry/H00544'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Aicardi_syndrome',
    value: 'Aicardi syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200562',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4393'
      ],
      other: [
        'https://www.kegg.jp/entry/H01776'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hemimegalencephaly',
    value: 'Hemimegalencephaly',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200563',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4783'
      ],
      other: [
        'https://www.kegg.jp/entry/H01833'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Focal_cortical_dysplasia',
    value: 'Focal cortical dysplasia',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200564',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4456'
      ],
      other: [
        'https://www.kegg.jp/entry/H01251'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Neuronal_migration_defects',
    value: 'Neuronal migration defects',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200574',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4396'
      ],
      other: [
        'https://www.kegg.jp/entry/H01835'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Epilepsy_with_myoclonic_atonic_seizures',
    value: 'Epilepsy with myoclonic atonic seizures',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200590',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4417'
      ],
      other: [
        'https://www.kegg.jp/entry/H01823'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lennox_Gastaut_syndrome',
    value: 'Lennox-Gastaut syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200591',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4889'
      ],
      other: [
        'https://www.kegg.jp/entry/H01813'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___West_syndrome',
    value: 'West syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200592',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4414'
      ],
      other: [
        'https://www.kegg.jp/entry/H01460'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Ohtahara_syndrome',
    value: 'Ohtahara syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200593',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4381'
      ],
      other: [
        'https://www.kegg.jp/entry/H00606'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Early_myoclonic_encephalopathy',
    value: 'Early myoclonic encephalopathy',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200594',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4705'
      ],
      other: [
        'https://www.kegg.jp/entry/H01819'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Epilepsy_of_infancy_with_migrating_focal_seizures',
    value: 'Epilepsy of infancy with migrating focal seizures',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200595',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4717'
      ],
      other: [
        'https://www.kegg.jp/entry/H01815'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hemiconvulsion_hemiplegia_epilepsy_syndrome',
    value: 'Hemiconvulsion-hemiplegia-epilepsy syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200596',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4408'
      ],
      other: [
        'https://www.kegg.jp/entry/H01808'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Rasmussens_encephalitis',
    value: 'Rasmussen\'s encephalitis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200598',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4339'
      ],
      other: [
        'https://www.kegg.jp/entry/H01812'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Developmental_and_or_epileptic_encephalopathy_with_spike_wave_activation_in_sleep',
    value: 'Developmental and/or epileptic encephalopathy with spike-wave activation in sleep',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200601',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4654'
      ],
      other: [
        'https://www.kegg.jp/entry/H01827'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Landau_Kleffner_syndrome',
    value: 'Landau-Kleffner syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200602',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4411'
      ],
      other: [
        'https://www.kegg.jp/entry/H01514'
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Rett_syndrome',
  //   value: 'Rett syndrome',
  //   type: 'default',
  //   difficuty: null,
  //   method: null,
  //   nandoID: 'NANDO:1200603',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/4366'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/H00440'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sturge_Weber_syndrome',
    value: 'Sturge-Weber syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200606',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4307'
      ],
      other: [
        'https://www.kegg.jp/entry/H01809'
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_ichthyosis',
  //   value: 'Congenital ichthyosis',
  //   type: 'default',
  //   difficuty: null,
  //   method: null,
  //   nandoID: 'NANDO:1200609',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/139'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/H01771'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pemphigoid_including_Epidermolysis_bullosa_acquisita',
    value: 'Pemphigoid (including Epidermolysis bullosa acquisita)',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200632',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4525'
      ],
      other: [
        'https://www.kegg.jp/entry/H01650'
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Oculocutaneous_albinism',
  //   value: 'Oculocutaneous albinism',
  //   type: 'default',
  //   difficuty: null,
  //   method: null,
  //   nandoID: 'NANDO:1200637',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/4492'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/H00168'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pseudoxanthoma_elasticum',
    value: 'Pseudoxanthoma elasticum',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200643',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4579'
      ],
      other: [
        'https://www.kegg.jp/entry/H00560'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___VATER_syndrome',
    value: 'VATER syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200657',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4850'
      ],
      other: [
        'https://www.kegg.jp/entry/H01195'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Joubert_syndrome_and_related_disorders',
    value: 'Joubert syndrome and related disorders',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200661',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4552'
      ],
      other: [
        'https://www.kegg.jp/entry/H00530'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Polysplenia_syndrome',
    value: 'Polysplenia syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200673',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5335'
      ],
      other: [
        'https://www.kegg.jp/entry/H01764'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Asplenia_syndrome',
    value: 'Asplenia syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200674',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5341'
      ],
      other: [
        'https://www.kegg.jp/entry/H01435'
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Werner_syndrome',
  //   value: 'Werner syndrome',
  //   type: 'default',
  //   difficuty: null,
  //   method: null,
  //   nandoID: 'NANDO:1200676',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/5320'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/H01733'
  //     ]
  //   }
  // },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cockayne_syndrome',
  //   value: 'Cockayne syndrome',
  //   type: 'default',
  //   difficuty: null,
  //   method: null,
  //   nandoID: 'NANDO:1200677',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/4435'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/H00076'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Truncus_arteriosus_communis',
    value: 'Truncus arteriosus communis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200693',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4895'
      ],
      other: [
        'https://www.kegg.jp/entry/H01736'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Corrected_transposition_of_great_arteries',
    value: 'Corrected transposition of great arteries',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200698',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4474'
      ],
      other: [
        'https://www.kegg.jp/entry/H01786'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Complete_transposition_of_the_great_arteries',
    value: 'Complete transposition of the great arteries',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200699',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4477'
      ],
      other: [
        'https://www.kegg.jp/entry/H00550'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hypoplastic_left_heart_syndrome',
    value: 'Hypoplastic left heart syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200705',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4372'
      ],
      other: [
        'https://www.kegg.jp/entry/H01272'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Tetralogy_of_Fallot',
    value: 'Tetralogy of Fallot',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200709',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4741'
      ],
      other: [
        'https://www.kegg.jp/entry/H00549'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Double_outlet_right_ventricle',
    value: 'Double outlet right ventricle',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200710',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4873'
      ],
      other: [
        'https://www.kegg.jp/entry/H00918'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Ebsteins_anomaly',
    value: 'Ebstein\'s anomaly',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200711',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4486'
      ],
      other: [
        'https://www.kegg.jp/entry/H01783'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Galloway_Mowat_syndrome',
    value: 'Galloway-Mowat syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200713',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4468'
      ],
      other: [
        'https://www.kegg.jp/entry/H01722'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_nephrotic_syndrome',
    value: 'Primary nephrotic syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200719',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4516'
      ],
      other: [
        'https://www.kegg.jp/entry/H01657'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Primary_membranoproliferative_glomerulonephritis',
    value: 'Primary membranoproliferative glomerulonephritis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200725',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4423'
      ],
      other: [
        'https://www.kegg.jp/entry/H01726'
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Alveolar_hypoventilation_syndrome',
  //   value: 'Alveolar hypoventilation syndrome',
  //   type: 'default',
  //   difficuty: null,
  //   method: null,
  //   nandoID: 'NANDO:1200751',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/172'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/H01727'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Alpha_1_antitrypsin_deficiency',
    value: 'Alpha-1-antitrypsin deficiency',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200755',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4738'
      ],
      other: [
        'https://www.kegg.jp/entry/H01103'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hypoparathyroidism',
    value: 'Hypoparathyroidism',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200775',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4426'
      ],
      other: [
        'https://www.kegg.jp/entry/H01862'
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Pseudohypoparathyroidism',
  //   value: 'Pseudohypoparathyroidism',
  //   type: 'default',
  //   difficuty: null,
  //   method: null,
  //   nandoID: 'NANDO:1200776',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/72'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/H00244'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Vitamin_D_resistant_rickets_Vitamin_D_resistant_osteomalacia',
    value: 'Vitamin D-resistant rickets/Vitamin D-resistant osteomalacia',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200778',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4558'
      ],
      other: [
        'https://www.kegg.jp/entry/H00214'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Tyrosinemia_type_1',
    value: 'Tyrosinemia type 1',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200788',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4690'
      ],
      other: [
        'https://www.kegg.jp/entry/H00165'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Tyrosinemia_type_2',
    value: 'Tyrosinemia type 2',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200789',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4693'
      ],
      other: [
        'https://www.kegg.jp/entry/H00165'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Tyrosinemia_type_3',
    value: 'Tyrosinemia type 3',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200790',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4696'
      ],
      other: [
        'https://www.kegg.jp/entry/H00165'
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Galactose_1_phosphate_uridyltransferase_deficiency',
  //   value: 'Galactose-1-phosphate uridyltransferase deficiency',
  //   type: 'default',
  //   difficuty: null,
  //   method: null,
  //   nandoID: 'NANDO:1200851',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/4828'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/H00070'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lecithin_cholesterol_acyltransferase_deficiency',
    value: 'Lecithin cholesterol acyltransferase deficiency',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200852',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4546'
      ],
      other: [
        'https://www.kegg.jp/entry/H00158'
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Sitosterolemia',
  //   value: 'Sitosterolemia',
  //   type: 'default',
  //   difficuty: null,
  //   method: null,
  //   nandoID: 'NANDO:1200853',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/4856'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/H00152'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Cerebrotendinous_xanthomatosis',
    value: 'Cerebrotendinous xanthomatosis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200856',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4618'
      ],
      other: [
        'https://www.kegg.jp/entry/H00151'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Chronic_recurrent_multifocal_osteomyelitis',
    value: 'Chronic recurrent multifocal osteomyelitis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200869',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4465'
      ],
      other: [
        'https://www.kegg.jp/entry/H01117'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Ankylosing_spondylitis',
    value: 'Ankylosing spondylitis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200870',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4847'
      ],
      other: [
        'https://www.kegg.jp/entry/H01674'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Fibrodysplasia_ossificans_progressiva',
    value: 'Fibrodysplasia ossificans progressiva',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200871',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/54'
      ],
      other: [
        'https://www.kegg.jp/entry/H00430'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_scoliosis_with_rib_anomalies',
    value: 'Congenital scoliosis with rib anomalies',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200872',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4645'
      ],
      other: [
        'https://www.kegg.jp/entry/H01851'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Giant_lymphatic_malformation_cervicofacial_lesion',
    value: 'Giant lymphatic malformation (cervicofacial lesion)',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200881',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4892'
      ],
      other: [
        'https://www.kegg.jp/entry/H01471'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Giant_venous_malformation_cervical_oral_and_oropharyngeal_diffuse_lesion',
    value: 'Giant venous malformation (cervical, oral and oropharyngeal diffuse lesion)',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200882',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4756'
      ],
      other: [
        'https://www.kegg.jp/entry/H00531'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Klippel_Trenaunay_Weber_syndrome',
    value: 'Klippel-Trenaunay-Weber syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200884',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4600'
      ],
      other: [
        'https://www.kegg.jp/entry/H01788'
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Diamond_Blackfan_anemia',
  //   value: 'Diamond-Blackfan anemia',
  //   type: 'default',
  //   difficuty: null,
  //   method: null,
  //   nandoID: 'NANDO:1200890',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/4420'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/H00237'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Hirschsprung_disease',
    value: 'Hirschsprung disease',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200903',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4699'
      ],
      other: [
        'https://www.kegg.jp/entry/H00910'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Congenital_diaphragmatic_hernia',
    value: 'Congenital diaphragmatic hernia',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200911',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4510'
      ],
      other: [
        'https://www.kegg.jp/entry/H01241'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Biliary_atresia',
    value: 'Biliary atresia',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200913',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4735'
      ],
      other: [
        'https://www.kegg.jp/entry/H01855'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Macular_dystrophy',
    value: 'Macular dystrophy',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1200931',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/4798'
      ],
      other: [
        'https://www.kegg.jp/entry/H01770'
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Progressive_leukoencephalopathy',
  //   value: 'Progressive leukoencephalopathy',
  //   type: 'default',
  //   difficuty: null,
  //   method: null,
  //   nandoID: 'NANDO:1200949',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/5416'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/H02598'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Anterior_segment_dysgenesis',
    value: 'Anterior segment dysgenesis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1201000',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5455'
      ],
      other: [
        'https://www.kegg.jp/entry/H01159'
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Aniridia',
  //   value: 'Aniridia',
  //   type: 'default',
  //   difficuty: null,
  //   method: null,
  //   nandoID: 'NANDO:1201001',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/5452'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/H00635'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Idiopathic_multicentric_Castlemans_disease',
    value: 'Idiopathic multicentric Castleman\'s disease',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1201005',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/5749'
      ],
      other: [
        'https://www.kegg.jp/entry/H01479'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Gelatinous_drop_like_corneal_dystrophy',
    value: 'Gelatinous drop-like corneal dystrophy',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1201006',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/6016'
      ],
      other: [
        'https://www.kegg.jp/entry/H00953'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___MECP2_Duplication_Syndrome',
    value: 'MECP2 Duplication Syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1201095',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28597'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Autosomal_Dominant_Adult_Onset_Demyelinating_Leukodystrophy',
    value: 'Autosomal Dominant Adult-Onset Demyelinating Leukodystrophy',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1201107',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28606'
      ],
      other: [
        'https://www.kegg.jp/entry/H01230'
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___PURA_related_severe_neonatal_hypotonia_seizures_encephalopathy_syndrome',
    value: 'PURA-related severe neonatal hypotonia-seizures-encephalopathy syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1201108',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28609'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___very_long_chain_acyl_CoA_dehydrogenase',
    value: 'very long-chain acyl-CoA dehydrogenase',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1201109',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28612'
      ],
      other: [
      ]
    }
  },
  // {
  //   title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___STING_stimulator_of_interferon_genes_associated_vasculopathy_with_onset_in_infancy',
  //   value: 'STING (stimulator of interferon genes)-associated vasculopathy with onset in infancy',
  //   type: 'default',
  //   difficuty: null,
  //   method: null,
  //   nandoID: 'NANDO:1201110',
  //   links: {
  //     center: [
  //       'https://www.nanbyou.or.jp/entry/28615'
  //     ],
  //     other: [
  //       'https://www.kegg.jp/entry/H01746'
  //     ]
  //   }
  // },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Bleeding_disorder_with_abnormal_fibrinolysis',
    value: 'Bleeding disorder with abnormal fibrinolysis',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1201112',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28621'
      ],
      other: [
      ]
    }
  },
  {
    title: 'CONSTANT.global.data.intractableDiseaseOptions.title.___Lowe_syndrome',
    value: 'Lowe syndrome',
    type: 'default',
    difficuty: null,
    method: null,
    nandoID: 'NANDO:1201116',
    links: {
      center: [
        'https://www.nanbyou.or.jp/entry/28624'
      ],
      other: [
        'https://www.kegg.jp/entry/H00692'
      ]
    }
  }
]

export const workgroupRoleOptions = [
  {
    title: 'CONSTANT.global.data.workgroupRoleOptions.title.___owner',
    value: 'Owner',
    editable: [
      'Director',
      'Member'
    ]
  },
  {
    title: 'CONSTANT.global.data.workgroupRoleOptions.title.___director',
    value: 'Director',
    editable: [
      'Director',
      'Member'
    ]
  },
  {
    title: 'CONSTANT.global.data.workgroupRoleOptions.title.___member',
    value: 'Member',
    editable: [
    ]
  }
]

export const licenseApiMap = _LOCAL_BUILD ? {
  'vcf_analysis': 'CONSTANT.global.data.licenseApiMap.title.___vcf_analysis',
  'fastq_analysis': 'CONSTANT.global.data.licenseApiMap.title.___fastq_analysis',
  'report_module': 'CONSTANT.global.data.licenseApiMap.title.___report_module'
} : {
  'mastermind': 'CONSTANT.global.data.licenseApiMap.title.___mastermind'
}

export const licenseStatusMap = {
  'inactive': 'CONSTANT.global.data.licenseStatusMap.title.___inactive',
  'active': 'CONSTANT.global.data.licenseStatusMap.title.___active',
  'exceeded': 'CONSTANT.global.data.licenseStatusMap.title.___exceeded',
  'expired': 'CONSTANT.global.data.licenseStatusMap.title.___expired',
  'unlimited': 'CONSTANT.global.data.licenseStatusMap.title.___unlimited'
}



// WEBPACK FOOTER //
// ./src/constants/global/data.js